
// import React, { useEffect, useState } from "react";
// import {
//   ResponsiveContainer,
//   LineChart,
//   Line,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
// } from "recharts";
// import { useNavigate } from "react-router-dom";
// import { useTheme as useMuiTheme } from '@mui/material/styles';
// import { useTheme as useCustomTheme } from '../../context/ThemeContext';
// import api from "../../services/api";

// // ─── Types ────────────────────────────────────────────────────────────────────
// interface Trend {
//   percentage: string;
//   direction: string;
// }

// interface KPIStat {
//   value: number;
//   trend: Trend;
// }

// interface RiskDistribution {
//   labels: string[];
//   values: number[];
//   colors: string[];
//   percentages: number[];
// }

// interface CategoryRisk {
//   score: number;
//   risk_level: string;
//   color: string;
// }

// interface RiskTrend {
//   months: string[];
//   scores: number[];
//   critical_count: number[];
//   high_count: number[];
//   medium_count: number[];
//   low_count: number[];
// }

// interface Vendor {
//   id: string;
//   name: string;
//   domain: string;
//   score: number;
//   risk_level: string;
//   category_scores: Record<string, number>;
//   top_issues: Array<{ indicator: string; severity: string; description: string }>;
//   last_assessed?: string;
//   issues?: number;
// }

// interface Assessment {
//   vendor_id: string;
//   vendor_name: string;
//   assessment_type: string;
//   due_date: string;
//   risk_level: string;
// }

// interface Alert {
//   id: string;
//   vendor_name: string;
//   title: string;
//   message: string;
//   severity: string;
//   time_ago: string;
// }

// interface DetailedCategory {
//   label: string;
//   value: number;
//   count: number;
// }

// interface BenchmarkScores {
//   overall: number;
//   cyber: number;
//   compliance: number;
// }

// interface RiskHeatMap {
//   rows: string[];
//   cols: string[];
//   data: number[][];
// }

// interface DashboardData {
//   kpis: {
//     total_vendors: KPIStat;
//     high_risk_vendors: KPIStat;
//     open_issues: KPIStat;
//     assessments_due: KPIStat;
//     critical_alerts: KPIStat;
//   };
//   risk_distribution: RiskDistribution;
//   category_risk_exposure: Record<string, CategoryRisk>;
//   risk_trend: RiskTrend;
//   top_high_risk_vendors: Vendor[];
//   upcoming_assessments: Assessment[];
//   recent_alerts: Alert[];
//   open_issues_by_severity: {
//     critical: number;
//     high: number;
//     medium: number;
//     low: number;
//     info: number;
//   };
//   detailed_categories: DetailedCategory[];
//   benchmark_scores: BenchmarkScores;
//   risk_heat_map: RiskHeatMap;
// }

// // ─── Risk Colors (semantic - stay the same) ─────────────────────────────────
// const RISK_COLORS = {
//   critical: "#dc2626",
//   high: "#ea580c",
//   medium: "#d97706",
//   low: "#16a34a",
//   veryLow: "#059669",
//   blue: "#3b82f6",
// };

// const RISK_LEVELS = ["Critical", "High", "Medium", "Low", "Very Low"];
// const RISK_LEVEL_COLORS = [RISK_COLORS.critical, RISK_COLORS.high, RISK_COLORS.medium, RISK_COLORS.low, RISK_COLORS.veryLow];

// // ─── Helper: Calculate real-time due days ─────────────────────────────────────
// function getDueDays(dueDateStr: string): { days: number; text: string; color: string } {
//   const currentYear = new Date().getFullYear();
//   const monthMap: Record<string, number> = {
//     Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5,
//     Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11
//   };

//   const parts = dueDateStr.split(" ");
//   const month = monthMap[parts[0]];
//   const day = parseInt(parts[1].replace("'", ""));

//   const dueDateTime = new Date(currentYear, month, day);
//   const today = new Date();
//   today.setHours(0, 0, 0, 0);

//   const diffTime = dueDateTime.getTime() - today.getTime();
//   const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

//   let color = RISK_COLORS.medium;
//   let text = "";

//   if (diffDays < 0) {
//     text = "Overdue";
//     color = "#dc2626";
//   } else if (diffDays === 0) {
//     text = "Due today";
//     color = "#dc2626";
//   } else if (diffDays === 1) {
//     text = "Due in 1 day";
//     color = "#dc2626";
//   } else if (diffDays <= 7) {
//     text = `Due in ${diffDays} days`;
//     color = "#dc2626";
//   } else if (diffDays <= 18) {
//     text = `Due in ${diffDays} days`;
//     color = RISK_COLORS.high;
//   } else {
//     text = `Due in ${diffDays} days`;
//     color = RISK_COLORS.medium;
//   }

//   return { days: diffDays, text, color };
// }

// // ─── Icons ────────────────────────────────────────────────────────────────────
// const icons = {
//   users: (
//     <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
//       <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" />
//       <path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" />
//     </svg>
//   ),
//   warning: (color: string = "#ea580c") => (
//     <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8">
//       <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
//       <line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" />
//     </svg>
//   ),
//   alert: (
//     <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
//       <circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" />
//     </svg>
//   ),
//   calendar: (
//     <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
//       <rect x="3" y="4" width="18" height="18" rx="2" /><line x1="16" y1="2" x2="16" y2="6" />
//       <line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" />
//     </svg>
//   ),
//   shield: (
//     <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
//       <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
//     </svg>
//   ),
//   arrowRight: (
//     <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//       <line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" />
//     </svg>
//   ),
//   trendUp: (
//     <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
//       <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" /><polyline points="17 6 23 6 23 12" />
//     </svg>
//   ),
//   trendDown: (
//     <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
//       <polyline points="23 18 13.5 8.5 8.5 13.5 1 6" /><polyline points="17 18 23 18 23 12" />
//     </svg>
//   ),
//   info: (
//     <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
//       <circle cx="12" cy="12" r="10" /><line x1="12" y1="16" x2="12" y2="12" /><line x1="12" y1="8" x2="12.01" y2="8" />
//     </svg>
//   ),
//   dot: (color: string) => (
//     <svg width="10" height="10" viewBox="0 0 10 10">
//       <circle cx="5" cy="5" r="4" fill={color} />
//     </svg>
//   ),
//   triWarning: (color: string = RISK_COLORS.high) => (
//     <svg width="16" height="16" viewBox="0 0 24 24" fill={color}>
//       <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
//       <line x1="12" y1="9" x2="12" y2="13" stroke="white" strokeWidth="1.5" />
//       <line x1="12" y1="17" x2="12.01" y2="17" stroke="white" strokeWidth="1.5" />
//     </svg>
//   ),
//   infoCircle: (
//     <svg width="16" height="16" viewBox="0 0 24 24" fill={RISK_COLORS.blue}>
//       <circle cx="12" cy="12" r="10" />
//       <line x1="12" y1="16" x2="12" y2="12" stroke="white" strokeWidth="1.5" />
//       <line x1="12" y1="8" x2="12.01" y2="8" stroke="white" strokeWidth="1.5" />
//     </svg>
//   ),
// };

// // ─── Sub-components ───────────────────────────────────────────────────────────
// interface CardProps {
//   children: React.ReactNode;
//   style?: React.CSSProperties;
//   p?: string;
//   themeColors: any;
// }

// function Card({ children, style = {}, p = "20px", themeColors }: CardProps) {
//   return (
//     <div style={{
//       background: themeColors.cardBg,
//       borderRadius: 10,
//       border: `1px solid ${themeColors.border}`,
//       boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
//       padding: p,
//       display: "flex",
//       flexDirection: "column",
//       ...style,
//     }}>
//       {children}
//     </div>
//   );
// }

// interface SectionTitleProps {
//   children: React.ReactNode;
//   action?: React.ReactNode;
//   themeColors: any;
// }

// function SectionTitle({ children, action, themeColors }: SectionTitleProps) {
//   return (
//     <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
//       <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
//         <span style={{ fontWeight: 600, fontSize: 15, color: themeColors.text }}>{children}</span>
//         <span style={{ color: themeColors.muted }}>{icons.info}</span>
//       </div>
//       {action}
//     </div>
//   );
// }

// interface KPICardProps {
//   icon: React.ReactNode;
//   iconBg: string;
//   title: string;
//   value: number;
//   trend: Trend;
//   themeColors: any;
// }

// function KPICard({ icon, iconBg, title, value, trend, themeColors }: KPICardProps) {
//   const isUp = trend.direction === "up";
//   const trendColor = isUp ? RISK_COLORS.critical : RISK_COLORS.low;
//   const isNew = trend.percentage === "NEW";

//   return (
//     <div style={{
//       background: themeColors.cardBg,
//       borderRadius: 10,
//       border: `1px solid ${themeColors.border}`,
//       boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
//       padding: "20px",
//       display: "flex",
//       flexDirection: "column",
//       flex: 1,
//       minWidth: 0,
//     }}>
//       <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 12 }}>
//         <div style={{ width: 40, height: 40, borderRadius: 10, background: iconBg, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
//           {icon}
//         </div>
//         <span style={{ fontSize: 13, color: themeColors.text, fontWeight: 600 }}>{title}</span>
//       </div>
//       <div style={{ fontSize: 34, fontWeight: 700, color: themeColors.text, lineHeight: 1 }}>
//         {value.toLocaleString()}
//       </div>
//       <div style={{ display: "flex", alignItems: "center", gap: 4, marginTop: 8 }}>
//         {isNew ? (
//           <span style={{ fontSize: 12, fontWeight: 600, color: RISK_COLORS.low }}>NEW</span>
//         ) : (
//           <>
//             <span style={{ color: trendColor, display: "flex", alignItems: "center" }}>
//               {isUp ? icons.trendUp : icons.trendDown}
//             </span>
//             <span style={{ fontSize: 12, fontWeight: 600, color: trendColor }}>{trend.percentage}</span>
//           </>
//         )}
//         <span style={{ fontSize: 12, color: themeColors.muted }}>vs previous period</span>
//       </div>
//     </div>
//   );
// }

// interface RiskChipProps { level: string; }

// function RiskChip({ level }: RiskChipProps) {
//   const colors: Record<string, string> = { 
//     Critical: RISK_COLORS.critical, 
//     High: "#fb923c" 
//   };
//   const bg = colors[level] ?? RISK_COLORS.medium;
//   return (
//     <span style={{ 
//       background: bg + "22", 
//       color: bg, 
//       border: `1px solid ${bg}55`, 
//       borderRadius: 6, 
//       padding: "2px 10px", 
//       fontSize: 12, 
//       fontWeight: 600 
//     }}>
//       {level}
//     </span>
//   );
// }

// interface DueChipProps { dueDate: string; }

// function DueChip({ dueDate }: DueChipProps) {
//   const { text, color } = getDueDays(dueDate);
//   return (
//     <span style={{ 
//       background: color + "15", 
//       color, 
//       border: `1px solid ${color}40`, 
//       borderRadius: 6, 
//       padding: "2px 10px", 
//       fontSize: 11, 
//       fontWeight: 600, 
//       whiteSpace: "nowrap" 
//     }}>
//       {text}
//     </span>
//   );
// }

// interface DonutSlice { value: number; color: string; }

// interface DonutChartProps {
//   data: DonutSlice[];
//   total: number;
//   cx?: number;
//   cy?: number;
//   r?: number;
//   innerR?: number;
//   themeColors: any;
// }

// function DonutChart({ data, total, cx = 80, cy = 80, r = 60, innerR = 38, themeColors }: DonutChartProps) {
//   let angle = -Math.PI / 2;
//   const slices = data.map(({ value, color }) => {
//     const frac = value / total;
//     const a0 = angle;
//     const a1 = angle + frac * 2 * Math.PI;
//     angle = a1;
//     const x0 = cx + r * Math.cos(a0), y0 = cy + r * Math.sin(a0);
//     const x1 = cx + r * Math.cos(a1), y1 = cy + r * Math.sin(a1);
//     const xi0 = cx + innerR * Math.cos(a0), yi0 = cy + innerR * Math.sin(a0);
//     const xi1 = cx + innerR * Math.cos(a1), yi1 = cy + innerR * Math.sin(a1);
//     const large = frac > 0.5 ? 1 : 0;
//     const d = `M${x0},${y0} A${r},${r} 0 ${large} 1 ${x1},${y1} L${xi1},${yi1} A${innerR},${innerR} 0 ${large} 0 ${xi0},${yi0} Z`;
//     return { d, color };
//   });
//   return (
//     <svg width={cx * 2} height={cy * 2}>
//       {slices.map((s, i) => <path key={i} d={s.d} fill={s.color} />)}
//       <text x={cx} y={cy - 5} textAnchor="middle" fontSize="22" fontWeight="700" fill={themeColors.text}>
//         {total.toLocaleString()}
//       </text>
//       <text x={cx} y={cy + 16} textAnchor="middle" fontSize="11" fill={themeColors.muted}>Total</text>
//     </svg>
//   );
// }

// // ─── Main Dashboard ───────────────────────────────────────────────────────────
// export default function Dashboard() {
//   const navigate = useNavigate();
//   const [data, setData] = useState<DashboardData | null>(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(false);
  
//   // ─── Theme Colors ──────────────────────────────────────────────────────────
//   const muiTheme = useMuiTheme();
//   const { mode } = useCustomTheme();
//   const isDark = mode === 'dark';

//   const themeColors = {
//     text: isDark ? '#e2e8f0' : '#0f172a',
//     muted: isDark ? '#6b7280' : '#64748b',
//     background: isDark ? '#000000' : '#f8fafc',
//     cardBg: isDark ? '#0d0d0d' : '#ffffff',
//     border: isDark ? '#1f1f1f' : '#e2e8f0',
//     hover: isDark ? '#141414' : '#f8fafc',
//     paper: isDark ? '#0d0d0d' : '#ffffff',
//     inputBg: isDark ? '#0d0d0d' : '#ffffff',
//     tableHead: isDark ? '#0d0d0d' : '#f8fafc',
//     tableRow: isDark ? '#111111' : '#ffffff',
//     tableRowHover: isDark ? '#181818' : '#f8fafc',
//     tableRowSelected: isDark ? '#0f1e38' : '#eff6ff',
//     panelSection: isDark ? '#1a1a1a' : '#f8fafc',
//     toggleSelected: isDark ? '#222222' : '#f1f5f9',
//   };

//   useEffect(() => {
//     api.get('/v1/dashboard/overview')
//       .then((response) => {
//         setData(response.data);
//         setLoading(false);
//       })
//       .catch((err) => {
//         console.error("Failed to load dashboard:", err);
//         setError(true);
//         setLoading(false);
//       });
//   }, []);

//   const handleVendorClick = (vendorId: string) => navigate(`/vendors/${vendorId}`);
//   const handleViewAllHighRisk = () => navigate("/vendors?tab=high_risk");
//   const handleViewRiskRegister = () => navigate("/vendors");
//   const handleViewAllAssessments = () => navigate("/vendors?tab=assessments");
//   const handleViewAllIssues = () => navigate("/vendors?tab=issues");
//   const handleViewAllAlerts = () => navigate("/monitoring");

//   if (loading) {
//     return (
//       <div style={{ background: themeColors.background, minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
//         <div style={{ width: 40, height: 40, border: `3px solid ${themeColors.border}`, borderTopColor: RISK_COLORS.blue, borderRadius: "50%", animation: "spin 0.8s linear infinite" }} />
//         <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
//       </div>
//     );
//   }

//   if (error || !data) {
//     return (
//       <div style={{ background: themeColors.background, minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
//         <div style={{
//           background: themeColors.cardBg,
//           borderRadius: 10,
//           border: `1px solid ${themeColors.border}`,
//           padding: "20px",
//         }}>
//           <p style={{ color: RISK_COLORS.critical, marginBottom: 16 }}>Failed to load dashboard data. Please check if backend is running and you are logged in.</p>
//           <button onClick={() => window.location.reload()} style={{
//             background: RISK_COLORS.blue, color: "white", border: "none", padding: "8px 16px", borderRadius: 6, cursor: "pointer"
//           }}>Retry</button>
//         </div>
//       </div>
//     );
//   }

//   const total = data.risk_distribution.values.reduce((a, b) => a + b, 0);

//   const trendData = data.risk_trend.months.map((m, i) => ({
//     month: m,
//     Critical: data.risk_trend.critical_count[i] || 0,
//     High: data.risk_trend.high_count[i] || 0,
//     Medium: data.risk_trend.medium_count[i] || 0,
//     Low: data.risk_trend.low_count[i] || 0,
//   }));

//   const catData = data.detailed_categories || [];

//   const issueData = [
//     { label: "Critical", value: data.open_issues_by_severity?.critical || 0, color: RISK_COLORS.critical },
//     { label: "High", value: data.open_issues_by_severity?.high || 0, color: RISK_COLORS.high },
//     { label: "Medium", value: data.open_issues_by_severity?.medium || 0, color: RISK_COLORS.medium },
//     { label: "Low", value: data.open_issues_by_severity?.low || 0, color: RISK_COLORS.low },
//   ];
//   const issueTotal = issueData.reduce((a, b) => a + b.value, 0);
//   issueData.forEach(item => {
//     (item as any).pct = issueTotal > 0 ? Math.round((item.value / issueTotal) * 100) : 0;
//   });

//   const overallScore = data.benchmark_scores?.overall || 0;
//   const cyberScore = data.benchmark_scores?.cyber || 0;
//   const compScore = data.benchmark_scores?.compliance || 0;

//   const heatMapData = data.risk_heat_map || {
//     rows: ["Almost Certain", "Likely", "Possible"],
//     cols: ["Insignificant", "Minor", "Moderate", "Major", "Severe"],
//     data: [
//       [2, 5, 11, 18, 21],
//       [4, 9, 20, 27, 14],
//       [7, 16, 26, 15, 8],
//     ],
//   };

//   const btn: React.CSSProperties = {
//     background: "none", 
//     border: "none", 
//     color: RISK_COLORS.blue, 
//     fontSize: 13,
//     fontWeight: 500, 
//     cursor: "pointer", 
//     display: "flex", 
//     alignItems: "center", 
//     gap: 4, 
//     padding: 0,
//   };

//   const avatarColors = [RISK_COLORS.critical, "#3b82f6", "#8b5cf6", "#06b6d4", RISK_COLORS.medium];
//   const avatarBgs = [RISK_COLORS.critical + "20", "#3b82f620", "#8b5cf620", "#06b6d420", RISK_COLORS.medium + "20"];
//   const fallbackDates = ["May 20, 2024", "May 18, 2024", "May 15, 2024", "May 21, 2024", "May 19, 2024"];

//   const lineKeys: [string, string][] = [
//     ["Critical", RISK_COLORS.critical], 
//     ["High", RISK_COLORS.high], 
//     ["Medium", RISK_COLORS.medium],
//     ["Low", RISK_COLORS.low],
//   ];

//   const benchmarkBars = [
//     { label: "Overall Risk Score", value: overallScore, color: RISK_COLORS.blue },
//     { label: "Cyber Risk Score", value: cyberScore, color: RISK_COLORS.critical },
//     { label: "Compliance Score", value: compScore, color: RISK_COLORS.medium },
//   ];

//   const benchmarkStats = [
//     { label: "Overall Risk Score", value: overallScore, sub: "vs Industry Avg" },
//     { label: "Cyber Risk Score", value: cyberScore, sub: "vs Industry Avg" },
//     { label: "Compliance Score", value: compScore, sub: "vs Industry Avg" },
//   ];

//   // ── Shared row grid style ──
//   const row3Col: React.CSSProperties = {
//     display: "grid",
//     gridTemplateColumns: "1fr 1fr 1fr",
//     gap: 16,
//     marginBottom: 20,
//     alignItems: "stretch",
//   };

//   return (
//     <div style={{ 
//       background: themeColors.background, 
//       minHeight: "100vh", 
//       padding: "20px 24px", 
//       fontFamily: "system-ui, -apple-system, sans-serif", 
//       color: themeColors.text 
//     }}>

//       <p style={{ 
//         fontSize: 13, 
//         color: themeColors.muted, 
//         letterSpacing: "0.04em", 
//         fontWeight: 500, 
//         marginBottom: 20, 
//         textTransform: "uppercase" 
//       }}>
//         Enterprise view of third-party risk across the extended ecosystem
//       </p>

//       {/* ── Row 1: KPI Cards (5 equal columns) ── */}
//       <div style={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: 16, marginBottom: 20, alignItems: "stretch" }}>
//         <KPICard 
//           icon={<span style={{ color: "#3b82f6" }}>{icons.users}</span>} 
//           iconBg={isDark ? "#0a1628" : "#dbeafe"} 
//           title="Total Third Parties" 
//           value={data.kpis.total_vendors.value} 
//           trend={data.kpis.total_vendors.trend}
//           themeColors={themeColors}
//         />
//         <KPICard 
//           icon={icons.warning(RISK_COLORS.high)} 
//           iconBg={isDark ? "#1a0a0a" : "#ffedd5"} 
//           title="High Risk Third Parties" 
//           value={data.kpis.high_risk_vendors.value} 
//           trend={data.kpis.high_risk_vendors.trend}
//           themeColors={themeColors}
//         />
//         <KPICard 
//           icon={<span style={{ color: RISK_COLORS.medium }}>{icons.alert}</span>} 
//           iconBg={isDark ? "#1a1400" : "#fef3c7"} 
//           title="Open Issues" 
//           value={data.kpis.open_issues.value} 
//           trend={data.kpis.open_issues.trend}
//           themeColors={themeColors}
//         />
//         <KPICard 
//           icon={<span style={{ color: "#8b5cf6" }}>{icons.calendar}</span>} 
//           iconBg={isDark ? "#150a1f" : "#ede9fe"} 
//           title="Assessments Due" 
//           value={data.kpis.assessments_due.value} 
//           trend={data.kpis.assessments_due.trend}
//           themeColors={themeColors}
//         />
//         <KPICard 
//           icon={<span style={{ color: "#0d9488" }}>{icons.shield}</span>} 
//           iconBg={isDark ? "#0a1a1a" : "#ccfbf1"} 
//           title="Incidents (Last 30 Days)" 
//           value={data.kpis.critical_alerts.value} 
//           trend={data.kpis.critical_alerts.trend}
//           themeColors={themeColors}
//         />
//       </div>

//       {/* ── Row 2: 3 equal columns ── */}
//       <div style={row3Col}>

//         {/* Third-Party Risk Exposure */}
//         <div style={{
//           background: themeColors.cardBg,
//           borderRadius: 10,
//           border: `1px solid ${themeColors.border}`,
//           boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
//           padding: "20px",
//           display: "flex",
//           flexDirection: "column",
//         }}>
//           <SectionTitle 
//             action={<button style={btn} onClick={handleViewRiskRegister}>View risk register {icons.arrowRight}</button>}
//             themeColors={themeColors}
//           >
//             Third-Party Risk Exposure
//           </SectionTitle>
//           <div style={{ display: "flex", justifyContent: "center", marginBottom: 16 }}>
//             <DonutChart
//               data={data.risk_distribution.values.map((v, i) => ({ value: v, color: RISK_LEVEL_COLORS[i] }))}
//               total={total}
//               themeColors={themeColors}
//             />
//           </div>
//           <div style={{ borderTop: `1px solid ${themeColors.border}`, paddingTop: 12, marginTop: "auto" }}>
//             <div style={{ display: "grid", gridTemplateColumns: "auto 1fr auto auto", gap: "6px 12px", alignItems: "center" }}>
//               <span style={{ fontSize: 10, fontWeight: 600, color: themeColors.muted, gridColumn: "2" }}>Risk Level</span>
//               <span style={{ fontSize: 10, fontWeight: 600, color: themeColors.muted, textAlign: "right" }}>Third Parties</span>
//               <span style={{ fontSize: 10, fontWeight: 600, color: themeColors.muted, textAlign: "right" }}>%</span>
//               {RISK_LEVELS.map((level, i) => (
//                 <React.Fragment key={level}>
//                   <span>{icons.dot(RISK_LEVEL_COLORS[i])}</span>
//                   <span style={{ fontSize: 13, color: themeColors.muted }}>{level}</span>
//                   <span style={{ fontSize: 13, fontWeight: 600, color: themeColors.text, textAlign: "right" }}>{data.risk_distribution.values[i]}</span>
//                   <span style={{ fontSize: 13, color: themeColors.muted, textAlign: "right" }}>{data.risk_distribution.percentages[i]}%</span>
//                 </React.Fragment>
//               ))}
//             </div>
//           </div>
//         </div>

//         {/* Risk Trend Over Time */}
//         <div style={{
//           background: themeColors.cardBg,
//           borderRadius: 10,
//           border: `1px solid ${themeColors.border}`,
//           boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
//           padding: "20px",
//           display: "flex",
//           flexDirection: "column",
//         }}>
//           <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
//             <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
//               <span style={{ fontWeight: 600, fontSize: 15, color: themeColors.text }}>Risk Trend Over Time</span>
//               <span style={{ color: themeColors.muted }}>{icons.info}</span>
//             </div>
//             <select style={{ 
//               fontSize: 12, 
//               border: `1px solid ${themeColors.border}`, 
//               borderRadius: 6, 
//               padding: "4px 8px", 
//               color: themeColors.muted, 
//               background: themeColors.inputBg,
//             }}>
//               <option>Last 6 Months</option>
//             </select>
//           </div>
//           <p style={{ fontSize: 11, color: themeColors.muted, margin: "0 0 8px" }}># of Third Parties by Risk Level</p>
//           <div style={{ flex: 1, minHeight: 0 }}>
//             <ResponsiveContainer width="100%" height={240}>
//               <LineChart data={trendData} margin={{ top: 5, right: 10, left: -20, bottom: 0 }}>
//                 <CartesianGrid strokeDasharray="3 3" stroke={themeColors.border} vertical={false} />
//                 <XAxis dataKey="month" tick={{ fontSize: 11, fill: themeColors.muted }} axisLine={false} tickLine={false} />
//                 <YAxis tick={{ fontSize: 11, fill: themeColors.muted }} axisLine={false} tickLine={false} />
//                 <Tooltip 
//                   contentStyle={{ 
//                     fontSize: 12, 
//                     borderRadius: 8, 
//                     border: `1px solid ${themeColors.border}`,
//                     background: themeColors.cardBg,
//                     color: themeColors.text,
//                   }} 
//                 />
//                 {lineKeys.map(([key, color]) => (
//                   <Line key={key} type="monotone" dataKey={key} stroke={color} strokeWidth={2} dot={{ r: 4, fill: color }} activeDot={{ r: 5 }} />
//                 ))}
//               </LineChart>
//             </ResponsiveContainer>
//           </div>
//           <div style={{ display: "flex", gap: 16, marginTop: 12, flexWrap: "wrap" }}>
//             {lineKeys.map(([k, c]) => (
//               <span key={k} style={{ display: "flex", alignItems: "center", gap: 5, fontSize: 11, color: themeColors.muted }}>
//                 <span style={{ display: "inline-block", width: 20, height: 2, background: c, borderRadius: 1 }} />
//                 {k}
//               </span>
//             ))}
//           </div>
//         </div>

//         {/* Risk Exposure by Category */}
//         <div style={{
//           background: themeColors.cardBg,
//           borderRadius: 10,
//           border: `1px solid ${themeColors.border}`,
//           boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
//           padding: "20px",
//           display: "flex",
//           flexDirection: "column",
//         }}>
//           <SectionTitle 
//             action={<button style={btn} onClick={handleViewAllAssessments}>View all {icons.arrowRight}</button>}
//             themeColors={themeColors}
//           >
//             Risk Exposure by Category
//           </SectionTitle>
//           <div style={{ flex: 1, overflow: "hidden" }}>
//             {catData.slice(0, 8).map((c) => (
//               <div key={c.label} style={{ marginBottom: 14 }}>
//                 <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 4 }}>
//                   <span style={{ fontSize: 13, color: themeColors.text }}>{c.label}</span>
//                   <span style={{ fontSize: 13, fontWeight: 600, color: themeColors.text }}>{c.value}</span>
//                 </div>
//                 <div style={{ height: 5, background: themeColors.border, borderRadius: 3, overflow: "hidden" }}>
//                   <div style={{ 
//                     height: "100%", 
//                     width: `${c.value}%`, 
//                     background: c.value >= 80 ? RISK_COLORS.low : c.value >= 60 ? RISK_COLORS.medium : RISK_COLORS.high, 
//                     borderRadius: 3 
//                   }} />
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>

//       {/* ── Row 3: 3 equal columns ── */}
//       <div style={row3Col}>

//         {/* Top High Risk Third Parties */}
//         <div style={{
//           background: themeColors.cardBg,
//           borderRadius: 10,
//           border: `1px solid ${themeColors.border}`,
//           boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
//           display: "flex",
//           flexDirection: "column",
//         }}>
//           <div style={{ padding: "16px 20px", borderBottom: `1px solid ${themeColors.border}` }}>
//             <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
//               <span style={{ fontWeight: 600, fontSize: 15, color: themeColors.text }}>Top High Risk Third Parties</span>
//               <span style={{ color: themeColors.muted }}>{icons.info}</span>
//             </div>
//           </div>
//           <div style={{ flex: 1, overflowX: "auto" }}>
//             <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
//               <thead>
//                 <tr style={{ background: themeColors.tableHead }}>
//                   {["Third Party", "Category", "Risk Rating", "Risk Score", "Last Assessed", ""].map((h) => (
//                     <th key={h} style={{ 
//                       padding: "10px 16px", 
//                       textAlign: "left", 
//                       fontSize: 11, 
//                       fontWeight: 600, 
//                       color: themeColors.muted, 
//                       borderBottom: `1px solid ${themeColors.border}` 
//                     }}>{h}</th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {data.top_high_risk_vendors.slice(0, 5).map((v, i) => (
//                   <tr
//                     key={v.id}
//                     style={{ 
//                       borderBottom: i < 4 ? `1px solid ${themeColors.border}` : "none", 
//                       cursor: "pointer",
//                       background: themeColors.tableRow,
//                     }}
//                     onClick={() => handleVendorClick(v.id)}
//                     onMouseEnter={(e) => { e.currentTarget.style.background = themeColors.tableRowHover; }}
//                     onMouseLeave={(e) => { e.currentTarget.style.background = themeColors.tableRow; }}
//                   >
//                     <td style={{ padding: "12px 16px" }}>
//                       <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//                         <div style={{
//                           width: 28, height: 28, borderRadius: 6,
//                           background: avatarBgs[i] ?? themeColors.muted + "20",
//                           display: "flex", alignItems: "center", justifyContent: "center",
//                           fontSize: 11, fontWeight: 700, color: avatarColors[i] ?? themeColors.muted,
//                           position: "relative",
//                           overflow: "hidden",
//                         }}>
//                           <img 
//                             src={`https://www.google.com/s2/favicons?domain=${v.domain}&sz=28`}
//                             alt=""
//                             style={{ width: 28, height: 28, position: "absolute" }}
//                             onError={(e) => {
//                               (e.target as HTMLImageElement).style.display = 'none';
//                             }}
//                             onLoad={(e) => {
//                               const parent = (e.target as HTMLImageElement).parentElement;
//                               if (parent) {
//                                 const span = parent.querySelector('span');
//                                 if (span) span.style.display = 'none';
//                               }
//                             }}
//                           />
//                           <span style={{ position: "relative", zIndex: 1 }}>
//                             {v.name.split(" ").map((w: string) => w[0]).slice(0, 2).join("")}
//                           </span>
//                         </div>
//                         <span style={{ fontWeight: 500, color: themeColors.text }}>{v.name}</span>
//                       </div>
//                     </td>
//                     <td style={{ padding: "12px 16px", color: themeColors.muted }}>{v.domain}</td>
//                     <td style={{ padding: "12px 16px" }}><RiskChip level={v.risk_level} /></td>
//                     <td style={{ padding: "12px 16px", fontWeight: 600, color: themeColors.text }}>{v.score} / 100</td>
//                     <td style={{ padding: "12px 16px", color: themeColors.muted }}>{v.last_assessed ? new Date(v.last_assessed).toLocaleDateString() : fallbackDates[i]}</td>
//                     <td style={{ padding: "12px 16px" }}><span style={{ color: themeColors.muted, cursor: "pointer" }}>⋮</span></td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//           <div style={{ padding: "14px 20px", borderTop: `1px solid ${themeColors.border}`, marginTop: "auto" }}>
//             <button style={btn} onClick={handleViewAllHighRisk}>View all high risk third parties {icons.arrowRight}</button>
//           </div>
//         </div>

//         {/* Upcoming Assessments */}
//         <div style={{
//           background: themeColors.cardBg,
//           borderRadius: 10,
//           border: `1px solid ${themeColors.border}`,
//           boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
//           padding: "20px",
//           display: "flex",
//           flexDirection: "column",
//         }}>
//           <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
//             <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
//               <span style={{ fontWeight: 600, fontSize: 15, color: themeColors.text }}>Upcoming Assessments</span>
//               <span style={{ color: themeColors.muted }}>{icons.info}</span>
//             </div>
//             <button style={{ ...btn, fontSize: 12 }}>View Calendar</button>
//           </div>
//           <div style={{ flex: 1 }}>
//             {data.upcoming_assessments.length > 0 ? (
//               data.upcoming_assessments.slice(0, 5).map((a, i) => {
//                 const parts = (a.due_date || "Jun 03").split(" ");
//                 const mon = parts[0] ?? "Jun";
//                 const day = (parts[1] ?? "03").replace("'", "");
//                 return (
//                   <div
//                     key={i}
//                     style={{ 
//                       display: "flex", 
//                       gap: 12, 
//                       marginBottom: 16, 
//                       alignItems: "flex-start", 
//                       paddingBottom: 12, 
//                       borderBottom: i < 4 ? `1px solid ${themeColors.border}` : "none", 
//                       cursor: "pointer",
//                       background: 'transparent',
//                     }}
//                     onClick={() => handleVendorClick(a.vendor_id)}
//                     onMouseEnter={(e) => { e.currentTarget.style.background = themeColors.tableRowHover; }}
//                     onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; }}
//                   >
//                     <div style={{ textAlign: "center", minWidth: 45 }}>
//                       <div style={{ fontSize: 10, fontWeight: 700, color: themeColors.muted, textTransform: "uppercase", letterSpacing: "0.05em" }}>{mon}</div>
//                       <div style={{ fontSize: 20, fontWeight: 700, color: themeColors.text, lineHeight: 1.2 }}>{day}</div>
//                     </div>
//                     <div style={{ flex: 1, minWidth: 0 }}>
//                       <div style={{ fontSize: 14, fontWeight: 600, color: themeColors.text, marginBottom: 4 }}>{a.vendor_name}</div>
//                       <div style={{ fontSize: 12, color: themeColors.muted, marginBottom: 6 }}>{a.assessment_type}</div>
//                       <DueChip dueDate={a.due_date} />
//                     </div>
//                   </div>
//                 );
//               })
//             ) : (
//               <div style={{ textAlign: "center", padding: "20px", color: themeColors.muted }}>No upcoming assessments</div>
//             )}
//           </div>
//           <button style={{ ...btn, marginTop: 8 }} onClick={handleViewAllAssessments}>View all assessments {icons.arrowRight}</button>
//         </div>

//         {/* Open Issues by Severity */}
//         <div style={{
//           background: themeColors.cardBg,
//           borderRadius: 10,
//           border: `1px solid ${themeColors.border}`,
//           boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
//           padding: "20px",
//           display: "flex",
//           flexDirection: "column",
//         }}>
//           <SectionTitle action={null} themeColors={themeColors}>
//             Open Issues by Severity
//           </SectionTitle>
//           <div style={{ display: "flex", justifyContent: "center", marginBottom: 12 }}>
//             {issueTotal > 0 ? (
//               <DonutChart
//                 data={issueData.map((x) => ({ value: x.value, color: x.color }))}
//                 total={issueTotal}
//                 cx={80} cy={80} r={60} innerR={38}
//                 themeColors={themeColors}
//               />
//             ) : (
//               <div style={{ width: 160, height: 160, display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
//                 <svg width="80" height="80" viewBox="0 0 80 80">
//                   <circle cx="40" cy="40" r="36" fill="none" stroke={themeColors.border} strokeWidth="8" />
//                   <text x="40" y="45" textAnchor="middle" fontSize="14" fontWeight="700" fill={themeColors.muted}>0</text>
//                 </svg>
//                 <span style={{ fontSize: 11, color: themeColors.muted, marginTop: 8 }}>No open issues</span>
//               </div>
//             )}
//           </div>
//           <div style={{ flex: 1 }}>
//             {issueData.map((item) => (
//               <div key={item.label} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
//                 <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
//                   {icons.dot(item.color)}
//                   <span style={{ fontSize: 13, color: themeColors.text }}>{item.label}</span>
//                 </div>
//                 <span style={{ fontSize: 13, fontWeight: 500, color: themeColors.muted }}>{item.value} ({(item as any).pct}%)</span>
//               </div>
//             ))}
//           </div>
//           <button style={{ ...btn, marginTop: 12 }} onClick={handleViewAllIssues}>View all issues {icons.arrowRight}</button>
//         </div>
//       </div>

//       {/* ── Row 4: 3 equal columns ── */}
//       <div style={row3Col}>

//         {/* Risk Heat Map */}
//         <div style={{
//           background: themeColors.cardBg,
//           borderRadius: 10,
//           border: `1px solid ${themeColors.border}`,
//           boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
//           padding: "20px",
//           display: "flex",
//           flexDirection: "column",
//         }}>
//           <SectionTitle action={null} themeColors={themeColors}>
//             Risk Heat Map
//           </SectionTitle>
//           <div style={{ flex: 1, overflowX: "auto" }}>
//             <div style={{ display: "flex", marginBottom: 6 }}>
//               <div style={{ width: 110, flexShrink: 0 }} />
//               <div style={{ fontSize: 11, fontWeight: 600, color: themeColors.muted, textAlign: "center", flex: 1 }}>Impact</div>
//             </div>
//             <div style={{ display: "flex", marginBottom: 4 }}>
//               <div style={{ width: 110, flexShrink: 0 }} />
//               {heatMapData.cols.map((c: string) => (
//                 <div key={c} style={{ flex: 1, fontSize: 10, color: themeColors.muted, textAlign: "center", fontWeight: 500 }}>{c}</div>
//               ))}
//             </div>
//             {heatMapData.rows.map((row: string, ri: number) => (
//               <div key={row} style={{ display: "flex", alignItems: "center", gap: 4, marginBottom: 4 }}>
//                 <div style={{ width: 106, fontSize: 11, color: themeColors.muted, fontWeight: 500, flexShrink: 0 }}>{row}</div>
//                 {heatMapData.data[ri].map((v: number, ci: number) => {
//                   const bg = v >= 20 ? "#fca5a5" : v >= 14 ? "#fdba74" : v >= 9 ? "#fde68a" : "#bbf7d0";
//                   const text = v >= 20 ? "#7f1d1d" : v >= 14 ? "#7c2d12" : v >= 9 ? "#78350f" : "#14532d";
//                   return (
//                     <div key={ci} style={{ flex: 1, height: 44, background: bg, borderRadius: 6, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 16, fontWeight: 700, color: text }}>
//                       {v}
//                     </div>
//                   );
//                 })}
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* Industry Benchmark */}
//         <div style={{
//           background: themeColors.cardBg,
//           borderRadius: 10,
//           border: `1px solid ${themeColors.border}`,
//           boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
//           padding: "20px",
//           display: "flex",
//           flexDirection: "column",
//         }}>
//           <SectionTitle action={null} themeColors={themeColors}>
//             Industry Benchmark
//           </SectionTitle>
//           <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 16, marginBottom: 20 }}>
//             {benchmarkStats.map(({ label, value, sub }) => (
//               <div key={label} style={{ textAlign: "center" }}>
//                 <div style={{ fontSize: 11, color: themeColors.muted, marginBottom: 4 }}>{label}</div>
//                 <div style={{ fontSize: 28, fontWeight: 700, color: themeColors.text }}>
//                   {value} <span style={{ fontSize: 14, fontWeight: 400, color: themeColors.muted }}>/100</span>
//                 </div>
//                 <div style={{ fontSize: 11, color: themeColors.muted, marginTop: 4 }}>{sub}</div>
//               </div>
//             ))}
//           </div>
//           <div style={{ flex: 1 }}>
//             {benchmarkBars.map(({ label, value, color }) => (
//               <div key={label} style={{ marginBottom: 12 }}>
//                 <div style={{ display: "flex", justifyContent: "space-between", fontSize: 12, marginBottom: 4 }}>
//                   <span style={{ color: themeColors.muted }}>{label}</span>
//                   <span style={{ fontWeight: 600, color: themeColors.text }}>{value}/100</span>
//                 </div>
//                 <div style={{ height: 6, background: themeColors.border, borderRadius: 3, overflow: "hidden" }}>
//                   <div style={{ height: "100%", width: `${value}%`, background: color, borderRadius: 3 }} />
//                 </div>
//               </div>
//             ))}
//           </div>
//           <button style={{ ...btn, marginTop: 8 }} onClick={handleViewAllAssessments}>View all assessments {icons.arrowRight}</button>
//         </div>

//         {/* Recent Alerts */}
//         <div style={{
//           background: themeColors.cardBg,
//           borderRadius: 10,
//           border: `1px solid ${themeColors.border}`,
//           boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
//           padding: "20px",
//           display: "flex",
//           flexDirection: "column",
//         }}>
//           <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
//             <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
//               <span style={{ fontWeight: 600, fontSize: 15, color: themeColors.text }}>Recent Alerts</span>
//               <span style={{ color: themeColors.muted }}>{icons.info}</span>
//             </div>
//             <button style={{ ...btn, fontSize: 12 }} onClick={handleViewAllAlerts}>View all alerts {icons.arrowRight}</button>
//           </div>
//           <div style={{ flex: 1 }}>
//             {data.recent_alerts.length > 0 ? (
//               data.recent_alerts.slice(0, 5).map((alert) => {
//                 const alertIcon = alert.severity === "info"
//                   ? icons.infoCircle
//                   : icons.triWarning(alert.severity === "critical" ? RISK_COLORS.critical : RISK_COLORS.high);
//                 return (
//                   <div
//                     key={alert.id}
//                     style={{ 
//                       display: "flex", 
//                       gap: 10, 
//                       marginBottom: 16, 
//                       paddingBottom: 16, 
//                       borderBottom: `1px solid ${themeColors.border}`, 
//                       cursor: "pointer",
//                       background: 'transparent',
//                     }}
//                     onClick={() => handleVendorClick(alert.id)}
//                     onMouseEnter={(e) => { e.currentTarget.style.background = themeColors.tableRowHover; }}
//                     onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; }}
//                   >
//                     <div style={{ marginTop: 1, flexShrink: 0 }}>{alertIcon}</div>
//                     <div style={{ flex: 1 }}>
//                       <div style={{ fontSize: 13, fontWeight: 500, color: themeColors.text, lineHeight: 1.4, marginBottom: 4 }}>{alert.title}</div>
//                       <div style={{ fontSize: 11, color: themeColors.muted }}>{alert.time_ago}</div>
//                     </div>
//                   </div>
//                 );
//               })
//             ) : (
//               <div style={{ textAlign: "center", padding: "20px", color: themeColors.muted }}>No recent alerts</div>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

import React, { useMemo, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Filler, Tooltip, Legend,
} from 'chart.js';
import {
  ReportProblemOutlined, TrendingDownOutlined, NotificationsActiveOutlined, BuildOutlined, RateReviewOutlined,
  AutoAwesomeOutlined, PersonAddAltOutlined, HowToRegOutlined, DescriptionOutlined, ScheduleOutlined,
  RadarOutlined, EventOutlined, CheckCircleOutline, AddOutlined, HubOutlined, ShieldOutlined, BusinessOutlined,
  InsightsOutlined, BugReportOutlined, DonutLargeOutlined, GridViewOutlined, CategoryOutlined, SwapVertOutlined,
  FilterAltOutlined, HistoryOutlined, FlagOutlined, LowPriorityOutlined, CompareArrowsOutlined, StorefrontOutlined,
  RequestQuoteOutlined,
} from '@mui/icons-material';
import { VendorLogo } from '../VendorRequests/VendorRequests';
import { dashboardQueries, CommandCenter } from '../../lib/queries';
import { useTheme as useCustomTheme } from '../../context/ThemeContext';
import { useAuth } from '../../context/AuthContext';
import { sans } from '../Vendors/VendorDetails';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Filler, Tooltip, Legend);

type Grade = 'A' | 'B' | 'C' | 'D' | 'F';
const GRADE_COLOR: Record<Grade, string> = { A: '#1D9E75', B: '#639922', C: '#EF9F27', D: '#D85A30', F: '#E24B4A' };
const GRADE_CHIP: Record<Grade, [string, string]> = {
  A: ['#E1F5EE', '#085041'], B: ['#EAF3DE', '#27500A'], C: ['#FAEEDA', '#633806'], D: ['#FAECE7', '#712B13'], F: ['#FCEBEB', '#791F1F'],
};
const GRADE_RANGE: Record<Grade, string> = { A: '90–100', B: '80–89', C: '70–79', D: '60–69', F: 'Below 60' };
const gradeOf = (s: number | null | undefined): Grade | null =>
  s == null ? null : s >= 90 ? 'A' : s >= 80 ? 'B' : s >= 70 ? 'C' : s >= 60 ? 'D' : 'F';

const SEVERITY_TONE: Record<string, { light: [string, string]; dark: [string, string] }> = {
  critical: { light: ['#FCEBEB', '#A32D2D'], dark: ['#3a1515', '#F09595'] },
  high: { light: ['#FAEEDA', '#854F0B'], dark: ['#3a2a10', '#FAC775'] },
  medium: { light: ['#E6F1FB', '#185FA5'], dark: ['#0c2a4a', '#85B7EB'] },
  ai: { light: ['#EEEDFE', '#534AB7'], dark: ['#211d4a', '#AFA9EC'] },
};

const ATTENTION_ICON: Record<string, React.ElementType> = {
  risk: ReportProblemOutlined, drop: TrendingDownOutlined, alert: NotificationsActiveOutlined, remediation: BuildOutlined,
  review: RateReviewOutlined, ai: AutoAwesomeOutlined, onboard: HowToRegOutlined, request: PersonAddAltOutlined,
  contract: DescriptionOutlined, stale: ScheduleOutlined,
};
const UPCOMING_ICON: Record<string, React.ElementType> = { scan: RadarOutlined, renewal: DescriptionOutlined, remediation: BuildOutlined };
const ACTIVITY_ICON: Record<string, React.ElementType> = {
  scan: RadarOutlined, alert: NotificationsActiveOutlined, request: PersonAddAltOutlined, remediation: CheckCircleOutline,
};

const fmtDay = (iso: string) => new Date(iso + (iso.length === 10 ? 'T00:00:00' : '')).toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
function timeAgo(iso: string | null) {
  if (!iso) return '';
  const diff = (Date.now() - new Date(iso.endsWith('Z') || iso.includes('+') ? iso : iso + 'Z').getTime()) / 1000;
  if (diff < 60) return 'just now';
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 172800) return 'yesterday';
  return `${Math.floor(diff / 86400)}d ago`;
}
const greeting = () => {
  const h = new Date().getHours();
  return h < 12 ? 'Good morning' : h < 17 ? 'Good afternoon' : 'Good evening';
};

function palette(isDark: boolean) {
  return {
    isDark,
    page: isDark ? '#000000' : '#F5F6FA',
    surface: isDark ? '#0d0d0d' : '#FFFFFF',
    surface2: isDark ? '#141414' : '#F8FAFC',
    track: isDark ? '#1f1f1f' : '#EEF2F6',
    line: isDark ? '#1f1f1f' : '#E2E8F0',
    ink: isDark ? '#F1F5F9' : '#0F172A',
    slate: isDark ? '#94A3B8' : '#64748B',
    muted: isDark ? '#64748B' : '#94A3B8',
    accent: isDark ? '#60A5FA' : '#185FA5',
    good: isDark ? '#4ADE80' : '#3B6D11',
    bad: isDark ? '#F87171' : '#A32D2D',
  };
}
type P = ReturnType<typeof palette>;

const chip = (p: P, g: Grade | null): React.CSSProperties => {
  const [bg, fg] = g ? GRADE_CHIP[g] : ['#F1F5F9', '#64748B'];
  return {
    fontSize: 11.5, fontWeight: 700, borderRadius: 99, padding: '3px 10px', whiteSpace: 'nowrap',
    background: p.isDark ? `${g ? GRADE_COLOR[g] : '#64748B'}2b` : bg, color: p.isDark ? (g ? GRADE_COLOR[g] : '#94A3B8') : fg,
  };
};

// Each section has its own hue: a coloured icon chip on every card, and a soft tint on the few cards
// that should stand out (KPI tiles, the AI briefing). Colour marks meaning, not decoration.
type Hue = 'red' | 'amber' | 'orange' | 'blue' | 'green' | 'purple' | 'teal' | 'indigo' | 'slate';
const HUE: Record<Hue, { chip: [string, string]; dchip: [string, string]; tint: string; dtint: string; line: string; dline: string }> = {
  red:    { chip: ['#FCEBEB', '#A32D2D'], dchip: ['#3a1515', '#F09595'], tint: '#FFF6F6', dtint: '#140a0a', line: '#F7D4D4', dline: '#3a1515' },
  amber:  { chip: ['#FAEEDA', '#854F0B'], dchip: ['#3a2a10', '#FAC775'], tint: '#FFFAF0', dtint: '#14100a', line: '#F3DDB2', dline: '#3a2a10' },
  orange: { chip: ['#FAECE7', '#993C1D'], dchip: ['#3a1c12', '#F0997B'], tint: '#FFF7F4', dtint: '#140c09', line: '#F5D3C6', dline: '#3a1c12' },
  blue:   { chip: ['#E6F1FB', '#185FA5'], dchip: ['#0c2a4a', '#85B7EB'], tint: '#F5F9FE', dtint: '#08121d', line: '#CFE2F6', dline: '#0c2a4a' },
  green:  { chip: ['#EAF3DE', '#3B6D11'], dchip: ['#18290a', '#97C459'], tint: '#F7FBF2', dtint: '#0b1306', line: '#D6E8BF', dline: '#18290a' },
  purple: { chip: ['#EEEDFE', '#534AB7'], dchip: ['#211d4a', '#AFA9EC'], tint: '#F8F7FF', dtint: '#0e0c20', line: '#DCD9FA', dline: '#2a2560' },
  teal:   { chip: ['#E1F5EE', '#0F6E56'], dchip: ['#0e3329', '#5DCAA5'], tint: '#F3FBF8', dtint: '#071511', line: '#C2EBDD', dline: '#0e3329' },
  indigo: { chip: ['#E8EAFD', '#3730A3'], dchip: ['#1c1f4a', '#A5B4FC'], tint: '#F6F7FF', dtint: '#0c0e20', line: '#D5DAFB', dline: '#1c1f4a' },
  slate:  { chip: ['#F1F5F9', '#475569'], dchip: ['#1e293b', '#CBD5E1'], tint: '#F8FAFC', dtint: '#0d0d0d', line: '#E2E8F0', dline: '#1f1f1f' },
};
const hueChip = (p: P, h: Hue) => (p.isDark ? HUE[h].dchip : HUE[h].chip);

// `fill`: the card takes its grid row's height and lays out as a column, so a caller can put a scrolling
// body (`.db-scroll`) in the middle and pin a footer to the bottom -- two cards side by side then always
// end level, however much text either one holds.
function Card({ p, title, right, children, style, onTitleClick, icon: Icon, hue = 'slate', tint, fill }: {
  p: P; title?: React.ReactNode; right?: React.ReactNode; children: React.ReactNode; style?: React.CSSProperties; onTitleClick?: () => void;
  icon?: React.ElementType; hue?: Hue; tint?: boolean; fill?: boolean;
}) {
  const [cbg, cfg] = hueChip(p, hue);
  return (
    <section style={{
      background: tint ? (p.isDark ? HUE[hue].dtint : HUE[hue].tint) : p.surface,
      border: `1px solid ${tint ? (p.isDark ? HUE[hue].dline : HUE[hue].line) : p.line}`,
      borderRadius: 12, padding: '18px 20px', minWidth: 0,
      ...(fill ? { display: 'flex', flexDirection: 'column', minHeight: 0 } : {}), ...style,
    }}>
      {title && (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10, marginBottom: 14 }}>
          <div onClick={onTitleClick} style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 14, fontWeight: 650, color: p.ink, cursor: onTitleClick ? 'pointer' : 'default', minWidth: 0 }}>
            {Icon && (
              <span style={{ width: 30, height: 30, borderRadius: 8, background: cbg, color: cfg, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <Icon sx={{ fontSize: 18 }} />
              </span>
            )}
            <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{title}</span>
          </div>
          {right}
        </div>
      )}
      {children}
    </section>
  );
}

const LinkBtn = ({ p, label, onClick }: { p: P; label: string; onClick: () => void }) => (
  <button onClick={onClick} style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', fontFamily: sans, fontSize: 12.5, fontWeight: 600, color: p.accent, whiteSpace: 'nowrap' }}>
    {label} →
  </button>
);

function ScoreRing({ p, score, size = 76 }: { p: P; score: number | null; size?: number }) {
  const g = gradeOf(score);
  const r = (size - 10) / 2;
  const c = 2 * Math.PI * r;
  const pct = score == null ? 0 : Math.max(0, Math.min(100, score)) / 100;
  return (
    <svg width={size} height={size} style={{ flexShrink: 0 }} role="img" aria-label={score == null ? 'Not rated' : `Score ${Math.round(score)}`}>
      <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={p.track} strokeWidth={7} />
      <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={g ? GRADE_COLOR[g] : p.muted} strokeWidth={7} strokeLinecap="round"
        strokeDasharray={`${c * pct} ${c}`} transform={`rotate(-90 ${size / 2} ${size / 2})`} style={{ transition: 'stroke-dasharray .6s ease' }} />
      <text x="50%" y="50%" dominantBaseline="central" textAnchor="middle" style={{ fontFamily: sans, fontSize: size * 0.3, fontWeight: 750, fill: p.ink }}>
        {score == null ? '–' : Math.round(score)}
      </text>
    </svg>
  );
}

function Sparkline({ values, color, height = 34 }: { values: (number | null)[]; color: string; height?: number }) {
  const pts = values.map((v, i) => [i, v] as [number, number | null]).filter((x): x is [number, number] => x[1] != null);
  if (pts.length < 2) return <div style={{ height }} />;
  const ys = pts.map(x => x[1]);
  const min = Math.min(...ys) - 2, max = Math.max(...ys) + 2;
  const w = 200;
  const toX = (i: number) => ((i - pts[0][0]) / Math.max(1, pts[pts.length - 1][0] - pts[0][0])) * w;
  const toY = (v: number) => height - ((v - min) / Math.max(1, max - min)) * (height - 4) - 2;
  const d = pts.map(([i, v], k) => `${k ? 'L' : 'M'}${toX(i).toFixed(1)},${toY(v).toFixed(1)}`).join(' ');
  return (
    <svg viewBox={`0 0 ${w} ${height}`} preserveAspectRatio="none" style={{ width: '100%', height }} aria-hidden="true">
      <path d={`${d} L${w},${height} L0,${height} Z`} fill={`${color}1f`} stroke="none" />
      <path d={d} fill="none" stroke={color} strokeWidth={2} vectorEffect="non-scaling-stroke" strokeLinejoin="round" />
    </svg>
  );
}

function Bar({ p, pct, color, height = 7 }: { p: P; pct: number; color: string; height?: number }) {
  return (
    <div style={{ height, borderRadius: 99, background: p.track, overflow: 'hidden' }}>
      <div style={{ width: `${Math.max(0, Math.min(100, pct))}%`, height: '100%', borderRadius: 99, background: color, transition: 'width .5s ease' }} />
    </div>
  );
}

const Empty = ({ p, children }: { p: P; children: React.ReactNode }) => (
  <div style={{ fontSize: 13, color: p.muted, padding: '18px 0', textAlign: 'center', lineHeight: 1.6 }}>{children}</div>
);

/* ─── Sections ──────────────────────────────────────────────────── */

// The first card on the dashboard: how many vendors the tenant monitors, how many joined in 30 days, and how they
// split across the scan's own risk bands (Low 80+, Medium 60-79, High 40-59, Critical below 40).
const RISK_BANDS: { key: 'low' | 'medium' | 'high' | 'critical'; label: string; color: string }[] = [
  { key: 'low', label: 'Low', color: '#1D9E75' }, { key: 'medium', label: 'Medium', color: '#EF9F27' },
  { key: 'high', label: 'High', color: '#D85A30' }, { key: 'critical', label: 'Critical', color: '#E24B4A' },
];

function TotalVendors({ p, total, summary, onOpen }: {
  p: P; total: number; summary?: CommandCenter['vendor_summary']; onOpen: () => void;
}) {
  const levels = summary?.risk_levels;
  const scored = levels ? RISK_BANDS.reduce((n, b) => n + levels[b.key], 0) : 0;
  const added = summary?.added_30d ?? 0;
  return (
    <Card p={p} title="Total vendors" icon={StorefrontOutlined} hue="blue" right={<LinkBtn p={p} label="View all" onClick={onOpen} />}>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 10 }}>
        <span style={{ fontSize: 40, fontWeight: 750, letterSpacing: '-.03em', lineHeight: 1, color: hueChip(p, 'blue')[1] }}>{total}</span>
        <span style={{ fontSize: 12.5, fontWeight: 600, color: added ? p.good : p.muted }}>
          {added ? `+${added} added in 30 days` : 'none added in 30 days'}
        </span>
      </div>
      {levels && scored > 0 ? (
        <>
          <div style={{ display: 'flex', height: 10, borderRadius: 99, overflow: 'hidden', gap: 3, marginTop: 16 }}>
            {RISK_BANDS.filter(b => levels[b.key]).map(b => (
              <div key={b.key} title={`${b.label} risk: ${levels[b.key]}`} style={{ flex: levels[b.key], background: b.color }} />
            ))}
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, minmax(0, 1fr))', gap: 6, marginTop: 12 }}>
            {RISK_BANDS.map(b => (
              <div key={b.key} style={{ minWidth: 0 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: 11.5, color: p.slate }}>
                  <span style={{ width: 8, height: 8, borderRadius: 99, background: b.color, flexShrink: 0 }} />{b.label}
                </div>
                <div style={{ fontSize: 16, fontWeight: 700, color: levels[b.key] ? p.ink : p.muted, marginTop: 1 }}>{levels[b.key]}</div>
              </div>
            ))}
          </div>
          {levels.unscored > 0 && <div style={{ fontSize: 12, color: p.muted, marginTop: 8 }}>{levels.unscored} not scanned yet</div>}
        </>
      ) : (
        <div style={{ fontSize: 12.5, color: p.muted, marginTop: 14 }}>The risk split appears once vendors have been scanned.</div>
      )}
    </Card>
  );
}

// White tile, coloured icon chip and number: colour carries the meaning, the card stays clean.
function StatusTile({ p, label, value, sub, hue, icon: Icon, onClick }: {
  p: P; label: string; value: number | string; sub: string; hue: Hue; icon: React.ElementType; onClick: () => void;
}) {
  const [cbg, cfg] = hueChip(p, hue);
  return (
    <button onClick={onClick} className="db-tile" style={{
      display: 'flex', alignItems: 'center', gap: 14, textAlign: 'left', background: p.surface, border: `1px solid ${p.line}`,
      borderRadius: 12, padding: '14px 16px', cursor: 'pointer', fontFamily: sans, minWidth: 0,
    }}>
      <span style={{ width: 44, height: 44, borderRadius: 11, background: cbg, color: cfg, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
        <Icon sx={{ fontSize: 23 }} />
      </span>
      <span style={{ minWidth: 0 }}>
        <span style={{ display: 'block', fontSize: 26, fontWeight: 750, color: cfg, lineHeight: 1.1, letterSpacing: '-.02em' }}>{value}</span>
        <span style={{ display: 'block', fontSize: 13, fontWeight: 600, color: p.ink, marginTop: 2 }}>{label}</span>
        <span style={{ display: 'block', fontSize: 12, color: p.slate, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{sub}</span>
      </span>
    </button>
  );
}

const BriefStat = ({ p, label, value, color }: { p: P; label: string; value: string; color: string }) => (
  <div style={{ background: p.surface2, border: `1px solid ${p.line}`, borderRadius: 10, padding: '10px 12px', minWidth: 0 }}>
    <div style={{ fontSize: 20, fontWeight: 750, color, lineHeight: 1.15, letterSpacing: '-.02em' }}>{value}</div>
    <div style={{ fontSize: 11.5, color: p.slate, marginTop: 2, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{label}</div>
  </div>
);

// Months before the first scan carry no data, so the chart starts at the first month that has a value
// (but always shows at least 3 months, so a single month still reads as a chart).
function trimTrend(data: CommandCenter['trend']) {
  const has = (i: number) => data.portfolio[i] != null || data.organization[i] != null;
  let first = data.months.findIndex((_, i) => has(i));
  if (first < 0) first = data.months.length - 1;
  first = Math.max(0, Math.min(first, data.months.length - 3));
  const cut = <T,>(a: T[] | undefined) => (a || []).slice(first);
  return { months: cut(data.months), portfolio: cut(data.portfolio), organization: cut(data.organization), counts: cut(data.portfolio_counts) };
}

function TrendChart({ p, data }: { p: P; data: CommandCenter['trend'] }) {
  const t = trimTrend(data);
  const grid = p.isDark ? 'rgba(148,163,184,.12)' : 'rgba(100,116,139,.12)';
  const all = [...t.portfolio, ...t.organization].filter((v): v is number => v != null);
  const min = all.length ? Math.max(0, Math.floor((Math.min(...all) - 8) / 10) * 10) : 0;
  const shown = t.counts.filter((c, i) => c > 0 && t.portfolio[i] != null);
  const countsVary = shown.length > 1 && Math.min(...shown) !== Math.max(...shown);
  return (
    <div>
      <div style={{ position: 'relative', height: countsVary ? 212 : 230 }}>
        <Line
          data={{
            labels: t.months,
            datasets: [
              // Drawn on top (lower order) with a white ring, so a single scan of your own company stays
              // visible even where it lands on the vendor-average point.
              { label: 'Your organization', data: t.organization, order: 0, borderColor: '#1D9E75', backgroundColor: '#1D9E75',
                pointBorderColor: p.surface, pointBorderWidth: 2, borderDash: [5, 4], borderWidth: 2.5,
                pointRadius: 5, pointHoverRadius: 7, cubicInterpolationMode: 'monotone', spanGaps: true },
              { label: 'Vendor average', data: t.portfolio, order: 1, borderColor: '#378ADD', backgroundColor: 'rgba(55,138,221,.12)', fill: true,
                pointBackgroundColor: '#378ADD', borderWidth: 2.5, pointRadius: 3, pointHoverRadius: 5, cubicInterpolationMode: 'monotone', spanGaps: true },
            ],
          }}
          options={{
            maintainAspectRatio: false,
            interaction: { mode: 'index', intersect: false },
            plugins: {
              legend: { position: 'bottom', reverse: true, labels: { boxWidth: 12, boxHeight: 3, color: p.slate, font: { family: 'Inter', size: 12 } } },
              tooltip: {
                animation: { duration: 0 },
                backgroundColor: p.isDark ? '#1E293B' : '#0F172A', titleColor: '#F8FAFC', bodyColor: '#E2E8F0',
                borderColor: p.isDark ? '#334155' : '#0F172A', borderWidth: 1, padding: 10, cornerRadius: 8,
                titleFont: { family: 'Inter', size: 12, weight: 'bold' }, bodyFont: { family: 'Inter', size: 12 },
                boxPadding: 4, usePointStyle: true, itemSort: (a, b) => b.datasetIndex - a.datasetIndex,
                filter: c => c.parsed.y != null,
                callbacks: {
                  label: c => {
                    const v = Math.round(c.parsed.y as number);
                    if (c.dataset.label !== 'Vendor average') return ` ${c.dataset.label}: ${v}`;
                    const n = t.counts[c.dataIndex];
                    return ` Vendor average: ${v}${n ? ` (${n} vendor${n === 1 ? '' : 's'})` : ''}`;
                  },
                },
              },
            },
            scales: {
              y: { min, max: 100, ticks: { color: p.muted, font: { size: 11 }, stepSize: 10 }, grid: { color: grid }, border: { display: false } },
              x: { ticks: { color: p.muted, font: { size: 11 } }, grid: { display: false }, border: { display: false } },
            },
          }}
        />
      </div>
      {countsVary && (
        <div style={{ fontSize: 11.5, color: p.muted, marginTop: 6, lineHeight: 1.45 }}>
          The average covers {Math.min(...shown)}–{Math.max(...shown)} vendors over this period, so it also moves when vendors are added.
        </div>
      )}
    </div>
  );
}

/** Header label for the trend card: how far back the (trimmed) chart actually goes. */
function trendRangeLabel(data: CommandCenter['trend']) {
  const n = trimTrend(data).months.length;
  return n >= 12 ? '12 months' : `Last ${n} months`;
}

function GradeDistribution({ p, grades, onOpen }: { p: P; grades: CommandCenter['grades']; onOpen: () => void }) {
  const order: Grade[] = ['A', 'B', 'C', 'D', 'F'];
  const total = order.reduce((s, g) => s + grades[g], 0);
  if (!total) return <Empty p={p}>No vendor has been scanned yet.</Empty>;
  return (
    <div>
      <div style={{ display: 'flex', height: 14, borderRadius: 99, overflow: 'hidden', gap: 3 }}>
        {order.filter(g => grades[g]).map(g => (
          <div key={g} title={`${g}: ${grades[g]}`} style={{ flex: grades[g], background: GRADE_COLOR[g] }} />
        ))}
      </div>
      <div style={{ marginTop: 14, display: 'grid', gap: 9 }}>
        {order.map(g => (
          <button key={g} onClick={onOpen} style={{ display: 'flex', alignItems: 'center', gap: 10, background: 'none', border: 'none', padding: 0, cursor: 'pointer', fontFamily: sans }}>
            <span style={{ ...chip(p, g), minWidth: 14, textAlign: 'center' }}>{g}</span>
            <span style={{ flex: 1, textAlign: 'left', fontSize: 13, color: p.slate }}>{GRADE_RANGE[g]}</span>
            <span style={{ fontSize: 13, color: p.muted, width: 40, textAlign: 'right' }}>{Math.round((grades[g] / total) * 100)}%</span>
            <span style={{ fontSize: 14, fontWeight: 700, color: p.ink, width: 26, textAlign: 'right' }}>{grades[g]}</span>
          </button>
        ))}
      </div>
      {grades.unscored > 0 && <div style={{ fontSize: 12, color: p.muted, marginTop: 10 }}>{grades.unscored} not scanned yet</div>}
    </div>
  );
}

// ── Risk heat map: every vendor placed by likelihood (posture) x impact (inherent tier). Counts per cell, never a
// score; the cell label is a lookup in the published 5x5 matrix (backend services/risk_heat_map.py owns the rules).
type HeatLevel = 'Low' | 'Medium' | 'High' | 'Critical';
type HeatVendor = CommandCenter['heat_map']['vendors'][number];
const HEAT_TONE: Record<HeatLevel, { light: [string, string, string]; dark: [string, string, string] }> = {
  // [background, border, text]
  Critical: { light: ['#F7D9D9', '#EDBDBD', '#A32D2D'], dark: ['#3d1515', '#5c2020', '#F09595'] },
  High: { light: ['#FCEBEA', '#F5D3CF', '#B4432B'], dark: ['#33170f', '#4d2418', '#F0997B'] },
  Medium: { light: ['#FCF1DC', '#F2DFB6', '#8A5A0B'], dark: ['#33270f', '#4d3a17', '#FAC775'] },
  Low: { light: ['#E4F2DD', '#C9E3BC', '#3B6D11'], dark: ['#15290c', '#234015', '#97C459'] },
};
const HEAT_ORDER: HeatLevel[] = ['Critical', 'High', 'Medium', 'Low'];

function RiskHeatMap({ p, hm, onOpenVendor }: {
  p: P; hm: CommandCenter['heat_map']; onOpenVendor: (id: string, tab?: string) => void;
}) {
  const [mode, setMode] = useState<'current' | 'residual'>('current');
  const [cell, setCell] = useState<{ l: number; i: number } | null>(null);
  const tone = (lvl: HeatLevel) => HEAT_TONE[lvl][p.isDark ? 'dark' : 'light'];
  const lik = (v: HeatVendor) => (mode === 'current' ? v.likelihood : v.residual_likelihood);
  const levelOf = (v: HeatVendor) => (mode === 'current' ? v.level : v.residual_level) as HeatLevel;
  const inCell = (l: number, i: number) => hm.vendors.filter(v => lik(v) === l && v.impact === i);
  const totals = HEAT_ORDER.map(lvl => ({ lvl, n: hm.vendors.filter(v => levelOf(v) === lvl).length }));
  const inRemediation = hm.vendors.filter(v => v.in_remediation).length;
  const selected = cell ? inCell(cell.l, cell.i) : [];
  const nothing = hm.vendors.length === 0 && hm.not_classified.length === 0 && hm.not_scanned.length === 0;
  const strong = { color: p.slate, fontWeight: 600 } as React.CSSProperties;

  if (nothing) return <Empty p={p}>Add and scan vendors to see them on the heat map.</Empty>;

  const seg = (key: 'current' | 'residual', label: string) => (
    <button onClick={() => setMode(key)} style={{
      padding: '6px 12px', fontSize: 12.5, fontWeight: 600, fontFamily: sans, cursor: 'pointer', borderRadius: 7,
      border: `1px solid ${mode === key ? p.accent : p.line}`, background: mode === key ? (p.isDark ? '#0C2A4A' : '#E6F1FB') : p.surface,
      color: mode === key ? (p.isDark ? '#B5D4F4' : '#0C447C') : p.slate,
    }}>{label}</button>
  );

  return (
    <div>
      <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', gap: 10, marginBottom: 14 }}>
        <div style={{ display: 'flex', gap: 6 }}>
          {seg('current', 'Current')}
          {seg('residual', inRemediation ? `After remediation · ${inRemediation}` : 'After remediation')}
        </div>
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
          {totals.map(({ lvl, n }) => {
            const [bg, , fg] = tone(lvl);
            return <span key={lvl} style={{ fontSize: 11.5, fontWeight: 600, padding: '3px 9px', borderRadius: 99, background: bg, color: fg, opacity: n ? 1 : 0.55 }}>{lvl} {n}</span>;
          })}
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '84px repeat(5, minmax(0, 1fr))', gap: 6 }}>
        <div style={{ fontSize: 10.5, color: p.muted, alignSelf: 'end', lineHeight: 1.3 }}>Likelihood ↓<br />Impact →</div>
        {hm.impact.map(c => (
          <div key={c.band} style={{ textAlign: 'center', fontSize: 11.5, color: p.slate, fontWeight: 600, paddingBottom: 2 }}>
            I{c.band}<div style={{ fontWeight: 400, color: p.muted, fontSize: 11 }}>{c.label}</div>
          </div>
        ))}
        {hm.likelihood.map(r => (
          <React.Fragment key={r.band}>
            <div style={{ fontSize: 11.5, color: p.slate, fontWeight: 600, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              L{r.band}<span style={{ fontWeight: 400, color: p.muted, fontSize: 11 }}>{r.label}</span>
            </div>
            {hm.impact.map(c => {
              const lvl = hm.levels[String(r.band)][String(c.band)] as HeatLevel;
              const n = inCell(r.band, c.band).length;
              const [bg, border, fg] = tone(lvl);
              const active = !!cell && cell.l === r.band && cell.i === c.band;
              return (
                <button key={c.band} disabled={!n} onClick={() => setCell(active ? null : { l: r.band, i: c.band })}
                  title={`L${r.band} ${r.label} × I${c.band} ${c.label}: ${lvl} · ${n} vendor${n === 1 ? '' : 's'}`}
                  style={{
                    height: 58, borderRadius: 9, background: bg, border: active ? `2px solid ${fg}` : `1px solid ${border}`,
                    cursor: n ? 'pointer' : 'default', fontFamily: sans, display: 'flex', flexDirection: 'column', alignItems: 'center',
                    justifyContent: 'center', gap: 1, padding: 0,
                  }}>
                  <span style={{ fontSize: 19, fontWeight: 700, color: fg, opacity: n ? 1 : 0.4, lineHeight: 1.1 }}>{n}</span>
                  <span style={{ fontSize: 10.5, fontWeight: 600, color: fg, opacity: n ? 0.9 : 0.45 }}>{lvl}</span>
                </button>
              );
            })}
          </React.Fragment>
        ))}
      </div>

      {cell && (
        <div style={{ marginTop: 14, border: `1px solid ${p.line}`, borderRadius: 10, overflow: 'hidden' }}>
          <div style={{ padding: '8px 12px', fontSize: 12, fontWeight: 600, color: p.slate, background: p.surface2, borderBottom: `1px solid ${p.line}`, display: 'flex', justifyContent: 'space-between' }}>
            <span>L{cell.l} {hm.likelihood.find(x => x.band === cell.l)?.label} × I{cell.i} {hm.impact.find(x => x.band === cell.i)?.label}</span>
            <button onClick={() => setCell(null)} style={{ background: 'none', border: 'none', color: p.muted, cursor: 'pointer', fontSize: 12, fontFamily: sans }}>Close</button>
          </div>
          {selected.map((v, idx) => (
            <button key={v.id} className="db-row-link" onClick={() => onOpenVendor(v.id)} style={{
              display: 'flex', alignItems: 'center', gap: 10, width: '100%', padding: '9px 12px', background: 'none', border: 'none',
              borderTop: idx ? `1px solid ${p.line}` : 'none', cursor: 'pointer', fontFamily: sans, textAlign: 'left',
            }}>
              <VendorLogo name={v.name} domain={v.domain} size={28} isDark={p.isDark} />
              <span style={{ flex: 1, minWidth: 0 }}>
                <span style={{ display: 'block', fontSize: 13, fontWeight: 600, color: p.ink }}>{v.name}</span>
                <span style={{ display: 'block', fontSize: 11.5, color: p.muted }}>
                  Likelihood: {mode === 'current' ? v.likelihood_why : v.residual_why} · Impact: {v.impact_why}
                  {mode === 'residual' && v.residual_likelihood !== v.likelihood ? ` · L${v.likelihood} before remediation` : ''}
                </span>
              </span>
              <span style={{ fontSize: 12.5, fontWeight: 600, color: p.accent, whiteSpace: 'nowrap' }}>Open →</span>
            </button>
          ))}
        </div>
      )}
      {!cell && hm.vendors.length > 0 && <div style={{ fontSize: 12, color: p.muted, marginTop: 10 }}>Click a cell to see which vendors are in it and why.</div>}

      {hm.not_classified.length > 0 && (
        <div style={{ marginTop: 12, padding: '10px 12px', borderRadius: 9, background: p.isDark ? '#33270f' : '#FCF1DC', color: p.isDark ? '#FAC775' : '#8A5A0B', fontSize: 12.5, lineHeight: 1.5 }}>
          <b style={{ fontWeight: 600 }}>{hm.not_classified.length} vendor{hm.not_classified.length === 1 ? '' : 's'} can&apos;t be placed yet.</b>{' '}
          Set data sensitivity, business criticality or system access on the Profile tab to give {hm.not_classified.length === 1 ? 'it' : 'them'} an impact:{' '}
          {hm.not_classified.slice(0, 5).map((v, i) => (
            <React.Fragment key={v.id}>{i ? ', ' : ''}
              <button onClick={() => onOpenVendor(v.id, 'profile')} style={{ background: 'none', border: 'none', padding: 0, color: 'inherit', textDecoration: 'underline', cursor: 'pointer', fontFamily: sans, fontSize: 12.5 }}>
                {v.name} (L{v.likelihood})
              </button>
            </React.Fragment>
          ))}{hm.not_classified.length > 5 ? ` and ${hm.not_classified.length - 5} more` : ''}.
        </div>
      )}
      {hm.not_scanned.length > 0 && (
        <div style={{ marginTop: 8, fontSize: 12, color: p.muted }}>
          {hm.not_scanned.length} vendor{hm.not_scanned.length === 1 ? ' has' : 's have'} no rating yet, so no likelihood: {hm.not_scanned.slice(0, 4).map(v => v.name).join(', ')}{hm.not_scanned.length > 4 ? '…' : ''}.
        </div>
      )}
      <details style={{ marginTop: 10, fontSize: 12, color: p.muted }}>
        <summary style={{ cursor: 'pointer', color: p.slate }}>How vendors are placed</summary>
        <div style={{ marginTop: 6, lineHeight: 1.6 }}>
          <b style={strong}>Likelihood</b> is the worse of the vendor&apos;s security rating (A → L1 … F → L5) and its open findings
          (1 critical → at least L4, 2+ critical → L5, 3+ high → at least L3, any high → at least L2).{' '}
          <b style={strong}>Impact</b> comes from its inherent risk tier, the highest of data sensitivity, business criticality and
          system access (Low → I1, Medium → I2, High → I3, High on two or more factors → I4, Critical → I5).{' '}
          <b style={strong}>After remediation</b> assumes every risk in an open remediation request gets fixed. Nothing here changes a vendor&apos;s score.
        </div>
      </details>
    </div>
  );
}

function FindingsBreakdown({ p, f, vendors }: { p: P; f: CommandCenter['findings']; vendors: number }) {
  const rows: [string, number, Hue][] = [['Critical', f.critical, 'red'], ['High', f.high, 'orange'], ['Medium', f.medium, 'amber'], ['Low', f.low, 'blue']];
  const total = rows.reduce((sum, r) => sum + r[1], 0);
  if (!total) return <Empty p={p}>No open findings across your vendors.</Empty>;
  const solid: Record<string, string> = { red: '#E24B4A', orange: '#D85A30', amber: '#EF9F27', blue: '#378ADD' };
  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 8 }}>
        <span style={{ fontSize: 30, fontWeight: 750, letterSpacing: '-.02em', color: p.ink }}>{total}</span>
        <span style={{ fontSize: 13, color: p.slate }}>findings across {vendors} vendor{vendors === 1 ? '' : 's'}</span>
      </div>
      <div style={{ display: 'flex', height: 10, borderRadius: 99, overflow: 'hidden', gap: 2, margin: '12px 0 14px' }}>
        {rows.filter(r => r[1]).map(([label, n, h]) => <div key={label} title={`${label}: ${n}`} style={{ flex: n, background: solid[h] }} />)}
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
        {rows.map(([label, n, h]) => {
          const [bg, fg] = hueChip(p, h);
          return (
            <div key={label} style={{ background: bg, borderRadius: 10, padding: '9px 12px' }}>
              <div style={{ fontSize: 12, fontWeight: 600, color: fg }}>{label}</div>
              <div style={{ fontSize: 20, fontWeight: 750, color: fg, lineHeight: 1.2 }}>{n}</div>
            </div>
          );
        })}
      </div>
      {f.vendors_with_critical > 0 && (
        <div style={{ fontSize: 12.5, color: p.slate, marginTop: 10 }}>
          {f.vendors_with_critical} vendor{f.vendors_with_critical === 1 ? ' has' : 's have'} at least one critical finding
        </div>
      )}
    </div>
  );
}

function Coverage({ p, c }: { p: P; c: CommandCenter['coverage'] }) {
  if (!c.total) return <Empty p={p}>No vendors yet.</Empty>;
  const pct = (n: number) => Math.round((n / c.total) * 100);
  const rows: [string, number, string][] = [
    ['Scanned in the last 7 days', c.scanned_7d, '#1D9E75'],
    ['Scanned in the last 30 days', c.scanned_30d, '#378ADD'],
    ['Scan scheduled in the next 60 days', c.scheduled, '#7F77DD'],
  ];
  const r = 34, circ = 2 * Math.PI * r, fresh = c.scanned_30d / c.total;
  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 14 }}>
        <svg width={84} height={84} role="img" aria-label={`${pct(c.scanned_30d)}% scanned in 30 days`} style={{ flexShrink: 0 }}>
          <circle cx={42} cy={42} r={r} fill="none" stroke={p.track} strokeWidth={8} />
          <circle cx={42} cy={42} r={r} fill="none" stroke="#378ADD" strokeWidth={8} strokeLinecap="round"
            strokeDasharray={`${circ * fresh} ${circ}`} transform="rotate(-90 42 42)" />
          <text x="50%" y="50%" dominantBaseline="central" textAnchor="middle" style={{ fontFamily: sans, fontSize: 18, fontWeight: 750, fill: p.ink }}>{pct(c.scanned_30d)}%</text>
        </svg>
        <div style={{ fontSize: 13, color: p.slate, lineHeight: 1.5 }}>
          of your vendors were scanned in the last 30 days
          {c.never > 0 && <div style={{ color: p.bad, fontWeight: 600 }}>{c.never} never scanned</div>}
        </div>
      </div>
      <div style={{ display: 'grid', gap: 11 }}>
        {rows.map(([label, n, col]) => (
          <div key={label}>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12.5, marginBottom: 5 }}>
              <span style={{ color: p.ink }}>{label}</span><span style={{ fontWeight: 700, color: p.ink }}>{n}/{c.total}</span>
            </div>
            <Bar p={p} pct={pct(n)} color={col} height={6} />
          </div>
        ))}
      </div>
    </div>
  );
}

// Pinned to the bottom of "Needs your attention": the next steps a user most often takes from here. It also
// keeps the card looking finished when the list is short, instead of ending in empty space. Actions a viewer
// can't perform are left out rather than shown and refused.
function QuickActions({ p, canEdit, navigate }: { p: P; canEdit: boolean; navigate: (to: string) => void }) {
  const actions: { label: string; icon: React.ElementType; hue: Hue; to: string }[] = [
    ...(canEdit ? [
      { label: 'New request', icon: PersonAddAltOutlined, hue: 'teal' as Hue, to: '/vendor-requests' },
      { label: 'Add vendor', icon: AddOutlined, hue: 'blue' as Hue, to: '/vendors/add' },
    ] : []),
    { label: 'Build a report', icon: DescriptionOutlined, hue: 'purple', to: '/reports' },
    { label: 'Compare vendors', icon: CompareArrowsOutlined, hue: 'amber', to: '/reports/comparison' },
  ];
  return (
    <div style={{ flexShrink: 0, marginTop: 12, paddingTop: 12, borderTop: `1px solid ${p.line}` }}>
      <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '.06em', textTransform: 'uppercase', color: p.muted, marginBottom: 8 }}>Quick actions</div>
      <div style={{ display: 'grid', gridTemplateColumns: `repeat(auto-fit, minmax(110px, 1fr))`, gap: 8 }}>
        {actions.map(a => {
          const [bg, fg] = hueChip(p, a.hue);
          return (
            <button key={a.label} className="db-qa" onClick={() => navigate(a.to)} style={{
              display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6, padding: '10px 8px', borderRadius: 10,
              border: `1px solid ${p.line}`, background: p.surface2, cursor: 'pointer', fontFamily: sans, fontSize: 12.5,
              fontWeight: 600, color: p.ink, minWidth: 0,
            }}>
              <span style={{ width: 32, height: 32, borderRadius: 9, background: bg, color: fg, display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                <a.icon sx={{ fontSize: 18 }} />
              </span>
              <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100%' }}>{a.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}

/* ─── Page ──────────────────────────────────────────────────────── */

export default function Dashboard() {
  const navigate = useNavigate();
  const { mode } = useCustomTheme();
  const { user } = useAuth();
  const p = useMemo(() => palette(mode === 'dark'), [mode]);
  const query = useQuery(dashboardQueries.commandCenter());
  const d = query.data;
  const canEdit = !!user && user.role !== 'viewer';
  const go = (link?: string | null, state?: Record<string, unknown>) => { if (link) navigate(link, state ? { state } : undefined); };

  const shell: React.CSSProperties = { fontFamily: sans, background: p.page, minHeight: '100%', padding: '24px 28px 40px', color: p.ink };
  const styles = `
    .db-row { display: grid; gap: 16px; margin-top: 16px; }
    .db-top { grid-template-columns: repeat(3, minmax(0, 1fr)); }
    .db-status { grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 12px; }
    .db-brief-stats { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 8px; flex-shrink: 0; }
    .db-item { transition: border-color .15s, background .15s; }
    .db-item:hover { border-color: ${p.accent} !important; background: ${p.surface2} !important; }
    .db-split { grid-template-columns: minmax(0, 1.45fr) minmax(0, 1fr); height: 340px; }
    .db-scroll { flex: 1; min-height: 0; overflow-y: auto; scrollbar-width: thin; scrollbar-color: ${p.line} transparent; margin-right: -8px; padding-right: 8px; }
    .db-scroll::-webkit-scrollbar { width: 6px; }
    .db-scroll::-webkit-scrollbar-thumb { background: ${p.line}; border-radius: 99px; }
    .db-qa { transition: border-color .15s, background .15s; }
    .db-qa:hover { border-color: ${p.accent} !important; background: ${p.surface2} !important; }
    .db-half { grid-template-columns: minmax(0, 1fr) minmax(0, 1fr); }
    .db-three { grid-template-columns: repeat(3, minmax(0, 1fr)); }
    .db-trio { grid-template-columns: minmax(0, 1.35fr) minmax(0, 1fr) minmax(0, 1fr); }
    .db-heat { grid-template-columns: minmax(0, 1.75fr) minmax(0, 1fr); }
    .db-kpis { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
    .db-tile { transition: border-color .15s, transform .15s; }
    .db-tile:hover { border-color: ${p.accent} !important; transform: translateY(-1px); }
    .db-row-link:hover { background: ${p.surface2}; }
    @media (max-width: 1180px) { .db-heat { grid-template-columns: minmax(0, 1fr); } .db-top { grid-template-columns: minmax(0, 1fr) minmax(0, 1fr); } .db-top > :first-child { grid-column: 1 / -1; } .db-status { grid-template-columns: repeat(2, minmax(0, 1fr)); } .db-three { grid-template-columns: 1fr 1fr; } .db-trio { grid-template-columns: 1fr 1fr; } .db-trio > :first-child { grid-column: 1 / -1; } }
    @media (max-width: 860px) { .db-top, .db-split, .db-half, .db-three, .db-trio { grid-template-columns: minmax(0, 1fr); } .db-status { grid-template-columns: 1fr 1fr; } .db-split { height: auto; } .db-split .db-scroll { max-height: 260px; } }
    @keyframes dbShimmer { 0% { opacity: .55 } 50% { opacity: 1 } 100% { opacity: .55 } }
  `;

  if (query.isPending) {
    return (
      <div style={shell}><style>{styles}</style>
        <div style={{ height: 52, width: 340, borderRadius: 10, background: p.surface2, animation: 'dbShimmer 1.2s infinite' }} />
        {[150, 280, 300].map((h, i) => (
          <div key={i} className="db-row db-half">{[0, 1].map(j => <div key={j} style={{ height: h, borderRadius: 12, background: p.surface2, animation: 'dbShimmer 1.2s infinite' }} />)}</div>
        ))}
      </div>
    );
  }
  if (query.isError || !d) {
    return (
      <div style={shell}>
        <Card p={p}><Empty p={p}>The dashboard couldn't load. <LinkBtn p={p} label="Try again" onClick={() => query.refetch()} /></Empty></Card>
      </div>
    );
  }

  const firstName = (user?.name || '').split(' ')[0];
  const k = d.kpis;
  const pf = d.portfolio;
  const org = d.organization;
  const pg = gradeOf(pf.score);
  const totalPipe = Math.max(1, d.pipeline.requested);
  const fpMax = Math.max(1, ...d.fourth_parties.map(f => f.vendors));

  return (
    <div style={shell}>
      <style>{styles}</style>

      {/* header */}
      <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', gap: 16, flexWrap: 'wrap' }}>
        <div>
          <div style={{ fontSize: 24, fontWeight: 750, letterSpacing: '-.02em' }}>{greeting()}{firstName ? `, ${firstName}` : ''}</div>
          <div style={{ fontSize: 13.5, color: p.slate, marginTop: 4 }}>
            {d.vendor_count} vendor{d.vendor_count === 1 ? '' : 's'} monitored
            {d.last_scan_at && <> · last scan {timeAgo(d.last_scan_at)}</>}
            {' · '}{new Date().toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' })}
          </div>
        </div>
        <div style={{ display: 'flex', gap: 10 }}>
          <button onClick={() => navigate('/reports?template=board')} style={{
            display: 'inline-flex', alignItems: 'center', gap: 7, padding: '9px 15px', borderRadius: 8, cursor: 'pointer', fontFamily: sans,
            fontSize: 13, fontWeight: 600, background: p.surface, color: p.ink, border: `1px solid ${p.line}`,
          }}><DescriptionOutlined sx={{ fontSize: 18 }} /> Board report</button>
          {canEdit && (
            <button onClick={() => navigate('/vendors/add')} style={{
              display: 'inline-flex', alignItems: 'center', gap: 7, padding: '9px 15px', borderRadius: 8, cursor: 'pointer', fontFamily: sans,
              fontSize: 13, fontWeight: 600, background: '#185FA5', color: '#fff', border: '1px solid #185FA5',
            }}><AddOutlined sx={{ fontSize: 18 }} /> Add vendor</button>
          )}
        </div>
      </div>

      {d.vendor_count === 0 ? (
        <Card p={p} style={{ marginTop: 20, textAlign: 'center', padding: '48px 24px' }}>
          <div style={{ fontSize: 18, fontWeight: 700 }}>Start monitoring your first vendor</div>
          <div style={{ fontSize: 14, color: p.slate, marginTop: 8 }}>Add a vendor and FluxWatch scans it right away. Your portfolio view fills in from there.</div>
          {canEdit && <button onClick={() => navigate('/vendors/add')} style={{ marginTop: 18, padding: '10px 18px', borderRadius: 8, border: 'none', background: '#185FA5', color: '#fff', fontWeight: 600, cursor: 'pointer', fontFamily: sans }}>Add vendor</button>}
        </Card>
      ) : (
        <>
          {/* total vendors + ratings */}
          <div className="db-row db-top">
            <TotalVendors p={p} total={d.vendor_count} summary={d.vendor_summary} onOpen={() => navigate('/vendors')} />

            <Card p={p} title="Portfolio rating" icon={ShieldOutlined} hue="green" right={<LinkBtn p={p} label="Vendors" onClick={() => navigate('/vendors')} />}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                <ScoreRing p={p} score={pf.score} size={84} />
                <div style={{ minWidth: 0, flex: 1 }}>
                  <span style={chip(p, pg)}>{pg ? `Grade ${pg}` : 'Not rated'}</span>
                  <div style={{ fontSize: 13, color: p.slate, marginTop: 8 }}>
                    {pf.change_30d == null ? 'No change data yet' : Math.round(pf.change_30d) === 0 ? 'No change in 30 days' : (
                      <><span style={{ color: pf.change_30d > 0 ? p.good : p.bad, fontWeight: 700 }}>{pf.change_30d > 0 ? '▲' : '▼'} {Math.abs(Math.round(pf.change_30d))}</span> in 30 days</>
                    )}
                  </div>
                  <div style={{ fontSize: 12, color: p.muted, marginTop: 2 }}>{pf.scanned} of {d.vendor_count} vendors scanned</div>
                  <div style={{ marginTop: 8 }}><Sparkline values={pf.monthly} color={pg ? GRADE_COLOR[pg] : '#378ADD'} height={26} /></div>
                </div>
              </div>
            </Card>

            <Card p={p} title="Your organization" icon={BusinessOutlined} hue="teal" right={org && <LinkBtn p={p} label="Open" onClick={() => navigate('/my-organization')} />}>
              {org ? (
                <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                  <ScoreRing p={p} score={org.score} size={84} />
                  <div style={{ minWidth: 0, flex: 1 }}>
                    <span style={chip(p, gradeOf(org.score))}>{gradeOf(org.score) ? `Grade ${gradeOf(org.score)}` : 'Not rated'}</span>
                    <div style={{ fontSize: 13, color: p.slate, marginTop: 8 }}>
                      {org.vs_portfolio == null ? '—' : Math.round(org.vs_portfolio) === 0 ? 'Level with your vendor average' : (
                        <><span style={{ fontWeight: 700, color: org.vs_portfolio > 0 ? p.good : p.bad }}>{Math.abs(Math.round(org.vs_portfolio))}</span> {org.vs_portfolio > 0 ? 'above' : 'below'} vendor average</>
                      )}
                    </div>
                    <div style={{ fontSize: 13, color: p.ink, marginTop: 10, fontWeight: 600, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{org.name}</div>
                    <div style={{ fontSize: 12, color: p.muted }}>{org.domain}</div>
                  </div>
                </div>
              ) : (
                <div>
                  <div style={{ fontSize: 13.5, color: p.slate, lineHeight: 1.55 }}>Scan your own company the same way you scan vendors, and compare it with them.</div>
                  <button onClick={() => navigate('/my-organization')} style={{ marginTop: 12, padding: '8px 14px', borderRadius: 8, border: `1px solid ${p.line}`, background: p.surface, color: p.ink, fontWeight: 600, cursor: 'pointer', fontFamily: sans, fontSize: 13 }}>Set up My Organization</button>
                </div>
              )}
            </Card>
          </div>

          {/* status strip */}
          <div className="db-row db-status">
            <StatusTile p={p} hue="red" icon={ReportProblemOutlined} label="Rated D or F" value={k.high_critical_vendors} sub={k.high_critical_vendors === 1 ? 'vendor scoring below 70' : 'vendors scoring below 70'} onClick={() => navigate('/vendors')} />
            <StatusTile p={p} hue="amber" icon={NotificationsActiveOutlined} label="Open alerts" value={k.open_alerts} sub={k.critical_alerts ? `${k.critical_alerts} critical` : 'none critical'} onClick={() => navigate('/monitoring')} />
            <StatusTile p={p} hue="blue" icon={BuildOutlined} label="Remediation open" value={k.remediation_open} sub={k.remediation_overdue ? `${k.remediation_overdue} overdue` : 'none overdue'} onClick={() => navigate('/remediation')} />
            <StatusTile p={p} hue="purple" icon={DescriptionOutlined} label="Renewals in 90 days" value={k.renewals_90d} sub={k.next_renewal ? `next: ${k.next_renewal.name}` : 'none coming up'} onClick={() => navigate('/vendors')} />
          </div>

          {/* financial exposure + briefing */}
          <div className="db-row db-split">
            <Card p={p} fill title="Estimated financial exposure" icon={RequestQuoteOutlined} hue="green" right={<LinkBtn p={p} label="Vendors" onClick={() => navigate('/vendors')} />}>
              {d.financial_exposure.vendor_count === 0 ? (
                <div className="db-scroll" style={{ display: 'flex', alignItems: 'center' }}>
                  <Empty p={p}>
                    {d.financial_exposure.total_vendor_count === 0
                      ? 'No vendors yet.'
                      : 'No vendors have both a completed scan and a submitted questionnaire response yet — estimates appear once both are available.'}
                  </Empty>
                </div>
              ) : (
                (() => {
                  // Colour = meaning: green best case, blue where the vendors sit today, red worst case.
                  const points: [string, Hue, keyof typeof d.financial_exposure.total_exposure_range][] = [
                    ['Minimum', 'green', 'minimum'], ['Most likely', 'blue', 'likely'], ['Maximum', 'red', 'maximum'],
                  ];
                  const riskHue: Record<string, Hue> = { Low: 'green', Medium: 'amber', High: 'orange', Critical: 'red' };
                  const sectionLabel: React.CSSProperties = { fontSize: 10.5, fontWeight: 700, color: p.muted, letterSpacing: '.04em', textTransform: 'uppercase', marginBottom: 6 };
                  const incomplete = d.financial_exposure.incomplete_vendor_count;
                  return (
                    <>
                      <div style={{ flexShrink: 0 }}>
                        <div style={sectionLabel}>
                          Portfolio total · {d.financial_exposure.vendor_count} vendor{d.financial_exposure.vendor_count === 1 ? '' : 's'}
                          {incomplete > 0 && <span style={{ textTransform: 'none', fontWeight: 500, color: p.muted }}>
                            {' '}· {incomplete} more need{incomplete === 1 ? 's' : ''} a scan + questionnaire response</span>}
                        </div>
                        <div style={{ display: 'flex', gap: 8, marginBottom: 10 }}>
                          {points.map(([label, hue, key]) => {
                            const [bg, fg] = hueChip(p, hue);
                            return (
                              <div key={label} style={{ flex: 1, padding: '7px 11px', borderRadius: 8, background: bg, border: `1px solid ${p.isDark ? HUE[hue].dline : HUE[hue].line}` }}>
                                <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: '.05em', textTransform: 'uppercase', color: fg, opacity: 0.85, marginBottom: 2 }}>{label}</div>
                                <div style={{ fontSize: 21, fontWeight: 800, letterSpacing: -0.4, color: fg, fontFamily: 'ui-monospace, monospace' }}>
                                  ${d.financial_exposure.total_exposure_range[key].toFixed(2)}M
                                </div>
                              </div>
                            );
                          })}
                        </div>

                        <div style={sectionLabel}>Average per vendor</div>
                        <div style={{ display: 'flex', gap: 8, marginBottom: 10 }}>
                          {points.map(([label, hue, key]) => (
                            <div key={label} style={{ flex: 1, display: 'flex', alignItems: 'center', gap: 7, padding: '5px 11px', borderRadius: 6, background: hueChip(p, hue)[0] }}>
                              <span style={{ width: 7, height: 7, borderRadius: 99, background: hueChip(p, hue)[1], flexShrink: 0 }} />
                              <span style={{ fontSize: 16, fontWeight: 700, color: hueChip(p, hue)[1], fontFamily: 'ui-monospace, monospace' }}>
                                ${d.financial_exposure.average_exposure_range[key].toFixed(2)}M
                              </span>
                            </div>
                          ))}
                        </div>
                      </div>

                      <div className="db-scroll">
                        <div style={sectionLabel}>Biggest contributors</div>
                        <div style={{ display: 'grid', gap: 4 }}>
                          {d.financial_exposure.top_contributors.map(v => {
                            const [rbg, rfg] = hueChip(p, riskHue[v.risk_level || ''] || 'slate');
                            return (
                              <button key={v.vendor_id} onClick={() => navigate(`/vendors/${v.vendor_id}`)} className="db-row-link" style={{
                                display: 'flex', alignItems: 'center', gap: 8, width: '100%', padding: '4px 0',
                                background: 'none', border: 'none', cursor: 'pointer', fontFamily: sans,
                              }}>
                                <span style={{ flex: 1, minWidth: 0, textAlign: 'left', fontSize: 13, color: p.ink, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{v.vendor_name}</span>
                                <span style={{ fontSize: 10.5, fontWeight: 700, borderRadius: 99, padding: '1px 8px', background: rbg, color: rfg, whiteSpace: 'nowrap' }}>{v.risk_level || 'Not scanned'}</span>
                                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: 13.5, fontWeight: 700, whiteSpace: 'nowrap', fontFamily: 'ui-monospace, monospace' }}>
                                  <span style={{ borderRadius: 6, padding: '1px 7px', background: hueChip(p, 'green')[0], color: hueChip(p, 'green')[1] }}>${v.exposure_range.minimum.toFixed(2)}M</span>
                                  <span style={{ color: p.muted }}>–</span>
                                  <span style={{ borderRadius: 6, padding: '1px 7px', background: hueChip(p, 'red')[0], color: hueChip(p, 'red')[1] }}>${v.exposure_range.maximum.toFixed(2)}M</span>
                                </span>
                              </button>
                            );
                          })}
                        </div>
                      </div>
                    </>
                  );
                })()
              )}
              <div style={{ fontSize: 11.5, color: p.muted, marginTop: 12, borderTop: `1px solid ${p.line}`, paddingTop: 10, flexShrink: 0, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                Estimate for prioritization only, not a valuation · IBM & Verizon 2026 reports
              </div>
            </Card>

            <Card p={p} fill title="This week's briefing" icon={AutoAwesomeOutlined} hue="purple"
              right={<span style={{ fontSize: 11.5, fontWeight: 700, borderRadius: 99, padding: '3px 10px', background: hueChip(p, 'purple')[0], color: hueChip(p, 'purple')[1] }}>
                {d.briefing.ai ? 'AI drafted' : 'Auto summary'}
              </span>}>
              <div className="db-brief-stats">
                <BriefStat p={p} label="Average score" value={pf.score == null ? '–' : (Math.round(pf.score * 10) / 10).toString()} color={pg ? GRADE_COLOR[pg] : p.ink} />
                <BriefStat p={p} label="Critical findings" value={String(d.findings.critical)} color={d.findings.critical ? p.bad : p.ink} />
                <BriefStat p={p} label="Rated D or F" value={String(k.high_critical_vendors)} color={k.high_critical_vendors ? p.bad : p.ink} />
              </div>
              <div className="db-scroll" style={{ marginTop: 12 }}>
              {d.briefing.points.length === 0 ? <Empty p={p}>The briefing appears once vendors have been scanned.</Empty> : (
                <div style={{ display: 'grid', gap: 10 }}>
                  {d.briefing.points.map((t, i) => (
                    <div key={i} style={{ display: 'flex', gap: 10, fontSize: 13.5, lineHeight: 1.55, color: p.ink }}>
                      <span style={{ width: 6, height: 6, borderRadius: 99, background: p.isDark ? '#AFA9EC' : '#7F77DD', marginTop: 8, flexShrink: 0 }} />
                      <span>{t}</span>
                    </div>
                  ))}
                </div>
              )}
              </div>
              <div style={{ fontSize: 12, color: p.muted, marginTop: 12, borderTop: `1px solid ${p.line}`, paddingTop: 10, flexShrink: 0, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {d.briefing.period_label ? `${d.briefing.period_label} · ` : ''}Numbers from your data · Sent every Monday
              </div>
            </Card>
          </div>

          {/* trend, findings, lowest rated */}
          <div className="db-row db-trio">
            <Card p={p} title="Score trend" icon={InsightsOutlined} hue="blue" right={<span style={{ fontSize: 12, color: p.muted }}>{trendRangeLabel(d.trend)}</span>}>
              <TrendChart p={p} data={d.trend} />
            </Card>
            <Card p={p} title="Open findings" icon={BugReportOutlined} hue="orange" right={<LinkBtn p={p} label="Vendors" onClick={() => navigate('/vendors')} />}>
              <FindingsBreakdown p={p} f={d.findings} vendors={d.vendor_count} />
            </Card>
            <Card p={p} title="Lowest rated vendors" icon={LowPriorityOutlined} hue="amber">
              {d.lowest.length === 0 ? <Empty p={p}>No vendor has been scanned yet.</Empty> : d.lowest.map((v, i) => {
                const g = gradeOf(v.score);
                return (
                  <button key={v.id} onClick={() => navigate(`/vendors/${v.id}`)} className="db-row-link" style={{
                    display: 'flex', alignItems: 'center', gap: 10, width: '100%', padding: '8px', margin: '0 -8px', boxSizing: 'content-box',
                    background: 'none', border: 'none', borderTop: i ? `1px solid ${p.line}` : 'none', cursor: 'pointer', fontFamily: sans, borderRadius: 6,
                  }}>
                    <VendorLogo name={v.name} domain={v.domain} size={30} isDark={p.isDark} />
                    <span style={{ flex: 1, minWidth: 0, textAlign: 'left' }}>
                      <span style={{ display: 'block', fontSize: 13.5, fontWeight: 600, color: p.ink, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{v.name}</span>
                      <span style={{ display: 'flex', gap: 6, marginTop: 3 }}>
                        {v.critical > 0 && <span style={{ fontSize: 11, fontWeight: 700, borderRadius: 99, padding: '1px 7px', background: hueChip(p, 'red')[0], color: hueChip(p, 'red')[1] }}>{v.critical} critical</span>}
                        {v.high > 0 && <span style={{ fontSize: 11, fontWeight: 700, borderRadius: 99, padding: '1px 7px', background: hueChip(p, 'orange')[0], color: hueChip(p, 'orange')[1] }}>{v.high} high</span>}
                        {!v.critical && !v.high && <span style={{ fontSize: 11.5, color: p.muted }}>No critical or high</span>}
                      </span>
                    </span>
                    <span style={{ ...chip(p, g), fontSize: 13 }}>{v.score}</span>
                  </button>
                );
              })}
            </Card>
          </div>

          {/* risk heat map, then grades and weakest categories */}
          <div className="db-row db-heat">
            <Card p={p} title="Risk heat map" icon={GridViewOutlined} hue="red" right={<span style={{ fontSize: 12, color: p.muted }}>Likelihood × impact</span>}>
              <RiskHeatMap p={p} hm={d.heat_map} onOpenVendor={(id, tab) => navigate(`/vendors/${id}`, tab ? { state: { tab } } : undefined)} />
            </Card>
            <div style={{ display: 'grid', gap: 16, alignContent: 'start', minWidth: 0 }}>
              <Card p={p} title="Grade distribution" icon={DonutLargeOutlined} hue="green" right={<LinkBtn p={p} label="Vendors" onClick={() => navigate('/vendors')} />}>
                <GradeDistribution p={p} grades={d.grades} onOpen={() => navigate('/vendors')} />
              </Card>
              <Card p={p} title="Weakest categories" icon={CategoryOutlined} hue="teal" right={<span style={{ fontSize: 12, color: p.muted }}>Portfolio avg</span>}>
                {d.categories.length === 0 ? <Empty p={p}>No category scores yet.</Empty> : (
                  <div style={{ display: 'grid', gap: 13 }}>
                    {d.categories.map(c => {
                      const col = c.avg < 70 ? '#E24B4A' : c.avg < 80 ? '#D85A30' : c.avg < 90 ? '#EF9F27' : '#639922';
                      return (
                        <div key={c.name}>
                          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, marginBottom: 6 }}>
                            <span style={{ color: p.ink }}>{c.name}</span>
                            <span style={{ fontWeight: 700, color: p.ink }}>{Math.round(c.avg)}</span>
                          </div>
                          <Bar p={p} pct={c.avg} color={col} />
                        </div>
                      );
                    })}
                  </div>
                )}
              </Card>
            </div>
          </div>

          {/* movers, pipeline, coming up */}
          <div className="db-row db-three">
            <Card p={p} title="Movers" icon={SwapVertOutlined} hue="blue" right={<span style={{ fontSize: 12, color: p.muted }}>30 days</span>}>
              {d.movers.declines.length + d.movers.improvements.length === 0 ? <Empty p={p}>No score changes in the last 30 days.</Empty> : (
                [...d.movers.declines, ...d.movers.improvements].map((m, i) => (
                  <button key={m.id} onClick={() => navigate(`/vendors/${m.id}`)} className="db-row-link" style={{
                    display: 'flex', alignItems: 'center', gap: 10, width: '100%', padding: '9px 8px', margin: '0 -8px', boxSizing: 'content-box',
                    background: 'none', border: 'none', borderTop: i ? `1px solid ${p.line}` : 'none', cursor: 'pointer', fontFamily: sans, borderRadius: 6,
                  }}>
                    <span style={{ flex: 1, textAlign: 'left', fontSize: 13.5, color: p.ink, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{m.name}</span>
                    <span style={{ fontSize: 12, color: p.muted }}>{m.from} → {m.to}</span>
                    <span style={{ fontSize: 13, fontWeight: 700, width: 44, textAlign: 'right', color: m.change < 0 ? p.bad : p.good }}>{m.change < 0 ? '▼' : '▲'} {Math.abs(m.change)}</span>
                  </button>
                ))
              )}
            </Card>

            <Card p={p} title="Onboarding pipeline" icon={FilterAltOutlined} hue="indigo" right={<LinkBtn p={p} label="Pre Onboarding" onClick={() => navigate('/vendor-requests')} />}>
              {d.pipeline.requested === 0 ? <Empty p={p}>No vendor requests yet.</Empty> : (
                <div style={{ display: 'grid', gap: 12 }}>
                  {([['Requested', d.pipeline.requested, '#B5D4F4'], ['Screened', d.pipeline.screened, '#85B7EB'], ['Approved', d.pipeline.approved, '#378ADD'], ['Onboarded', d.pipeline.onboarded, '#185FA5']] as [string, number, string][]).map(([label, v, col]) => (
                    <div key={label}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, marginBottom: 6 }}><span style={{ color: p.ink }}>{label}</span><span style={{ fontWeight: 700 }}>{v}</span></div>
                      <Bar p={p} pct={(v / totalPipe) * 100} color={col} />
                    </div>
                  ))}
                  {d.pipeline.rejected > 0 && <div style={{ fontSize: 12, color: p.muted }}>{d.pipeline.rejected} rejected</div>}
                </div>
              )}
            </Card>

            <Card p={p} title="Coming up" icon={EventOutlined} hue="teal">
              {d.upcoming.length === 0 ? <Empty p={p}>Nothing scheduled in the next weeks.</Empty> : d.upcoming.map((u, i) => {
                const Icon = UPCOMING_ICON[u.kind] || EventOutlined;
                return (
                  <button key={i} onClick={() => go(u.link)} className="db-row-link" style={{
                    display: 'flex', alignItems: 'center', gap: 10, width: '100%', padding: '9px 8px', margin: '0 -8px', boxSizing: 'content-box',
                    background: 'none', border: 'none', borderTop: i ? `1px solid ${p.line}` : 'none', cursor: 'pointer', fontFamily: sans, borderRadius: 6,
                  }}>
                    <Icon sx={{ fontSize: 18, color: p.slate }} />
                    <span style={{ fontSize: 12.5, color: p.muted, width: 50, textAlign: 'left', flexShrink: 0 }}>{fmtDay(u.date)}</span>
                    <span style={{ flex: 1, textAlign: 'left', fontSize: 13.5, color: p.ink, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{u.title}</span>
                  </button>
                );
              })}
            </Card>
          </div>

          {/* fourth parties, scan coverage, activity */}
          <div className="db-row db-three">
            <Card p={p} title="Shared fourth parties" icon={HubOutlined} hue="amber"
              right={<span style={{ fontSize: 11.5, fontWeight: 700, borderRadius: 99, padding: '3px 10px', background: p.isDark ? '#3a2a10' : '#FAEEDA', color: p.isDark ? '#FAC775' : '#633806' }}>Concentration</span>}>
              {d.fourth_parties.length === 0 ? <Empty p={p}>No provider is shared by two or more of your vendors yet.</Empty> : (
                <div style={{ display: 'grid', gap: 12 }}>
                  {d.fourth_parties.map(f => (
                    <div key={f.domain + f.company} title={f.vendor_names.join(', ')}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10, fontSize: 13, marginBottom: 6 }}>
                        <span style={{ color: p.ink, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{f.company}</span>
                        <span style={{ color: p.slate, whiteSpace: 'nowrap' }}><b style={{ color: p.ink }}>{f.vendors}</b> of {d.vendor_count} vendors</span>
                      </div>
                      <Bar p={p} pct={(f.vendors / fpMax) * 100} color="#BA7517" />
                    </div>
                  ))}
                  <div style={{ fontSize: 12, color: p.muted }}>Providers many of your vendors rely on. One outage there would hit all of them.</div>
                </div>
              )}
            </Card>

            <Card p={p} title="Scan coverage" icon={RadarOutlined} hue="indigo" right={<LinkBtn p={p} label="Schedule" onClick={() => navigate('/schedule')} />}>
              <Coverage p={p} c={d.coverage} />
            </Card>

            <Card p={p} title="Recent activity" icon={HistoryOutlined} hue="slate">
              {d.activity.length === 0 ? <Empty p={p}>No activity yet.</Empty> : d.activity.map((a, i) => {
                const Icon = ACTIVITY_ICON[a.kind] || EventOutlined;
                const color = a.kind === 'alert' && (a.severity === 'critical' || a.severity === 'high') ? p.bad : a.kind === 'remediation' ? '#1D9E75' : p.slate;
                return (
                  <button key={i} onClick={() => go(a.link)} className="db-row-link" style={{
                    display: 'flex', alignItems: 'center', gap: 10, width: '100%', padding: '9px 8px', margin: '0 -8px', boxSizing: 'content-box',
                    background: 'none', border: 'none', borderTop: i ? `1px solid ${p.line}` : 'none', cursor: a.link ? 'pointer' : 'default', fontFamily: sans, borderRadius: 6,
                  }}>
                    <Icon sx={{ fontSize: 18, color }} />
                    <span style={{ flex: 1, textAlign: 'left', fontSize: 13.5, color: p.ink, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{a.title}</span>
                    <span style={{ fontSize: 12, color: p.muted, whiteSpace: 'nowrap' }}>{timeAgo(a.at)}</span>
                  </button>
                );
              })}
              <div style={{ marginTop: 10 }}><LinkBtn p={p} label="Audit log" onClick={() => navigate('/audit-logs')} /></div>
            </Card>
          </div>

        </>
      )}
    </div>
  );
}
